import React, { Component, createRef } from 'react'
import Button from '@material-ui/core/Button';
import { Grid, AppBar, Toolbar, Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, Typography, Box, TextField, InputAdornment, Slide, Tab, Tabs, Popover, List, ListItem, Stepper, Step, StepLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ZoomIn from '@material-ui/icons/ZoomIn';
import ZoomOut from '@material-ui/icons/ZoomOut';
import moment from 'moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker } from "@material-ui/pickers";
import FormControl from '@material-ui/core/FormControl';
import EmpTable from './PRPEmpTable';
import CloseIcon from '@material-ui/icons/Close';
import Service from '../../config/networkutils';
import { weekStartDates } from '../../utils/betweenDates';
import {
    prp_roles_api,
    prp_roles_api_bulk_update,
    prptandPrprDeleteByPRPtid,
    conditionalPRPTandPRPRcreate,
} from '../../config/apiList';
import RotateCircleLoading from 'react-loadingg/lib/RotateCircleLoading';
import { withSnackbar } from 'notistack';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import Modal from '../../shared/Modal/Modal';
import Dropzone from '../../shared/Dropzone/Dropzone';
import { getCookie } from '../../utils/CookieHelper';
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { getActiveRoles, getRoleGroups, getSubSector } from '../../config/PromisesHandler';
import { getLookupObj, getRolesLookupObj } from '../../utils/reuseFunctions';
// import { generalSortOrder } from '../../config/abstractedVariables';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteIcon from '@material-ui/icons/Delete';
import { KeyboardDatePicker } from '@material-ui/pickers';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcom from '@material-ui/icons/RemoveCircle';
import SearchIcon from '@material-ui/icons/Search';
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import UserAllocation from '../UserAllocation/UserAllocation';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Alert from '@material-ui/lab/Alert';
import WorkIcon from '@material-ui/icons/Work';
import { getDataIsdeletedFalse, getPrimaryColor, getSecondaryColor } from '../Helper/CommonThings';
import AllocateSchedules from '../UserAllocation/AllocateSchedules';
import SplitDemandRole from '../UserAllocation/SplitDemandRole';
import AssignSubContractor from '../SubContractor/AssignSubContractor';
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state';
import { CoffeeLoading } from 'react-loadingg';
import EditIcon from "@material-ui/icons/Edit";
import CheckIcon from '@material-ui/icons/Check';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import AtrAllocation from '../ATR/AtrAllocation';
import ResourceProfileTable from '../ResourceProfile/ResourceProfileTable';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const token = getCookie("ptd_ts_token");
const MAX_UPLOAD_SIZE_BYTES = 15 * 1024 * 1024
const MAX_UPLOAD_ROWS = 10000
const importProfileSections = [
    { key: 'eci', label: 'ECI', startDateKey: 'eci_start_date', endDateKey: 'eci_end_date' },
    { key: 'stage1', label: 'Stage 1', startDateKey: 'stage1_start_date', endDateKey: 'stage1_end_date' },
    { key: 'stage2', label: 'Stage 2', startDateKey: 'stage2_start_date', endDateKey: 'stage2_end_date' },
]

const toPickerDate = value => value && moment(value).isValid() ? moment(value).toDate() : null
const buildImportProfileSelections = project => importProfileSections.reduce((selections, section) => {
    selections[section.key] = {
        startDate: toPickerDate(project?.[section.startDateKey]),
        endDate: toPickerDate(project?.[section.endDateKey]),
        key: section.key,
        label: section.label,
        stage: '',
        disciplineIds: [],
    }
    return selections
}, { contractAwardValue: project?.contract_award_value ?? '' })
const getImportProfileDetailsSignature = selections => JSON.stringify({
    contractAwardValue: String(selections?.contractAwardValue ?? ''),
    sections: importProfileSections.map(section => {
        const selection = selections?.[section.key] || {}
        const formatDate = value => value && moment(value).isValid()
            ? moment(value).format('YYYY-MM-DD')
            : null

        return {
            startDate: formatDate(selection.startDate),
            endDate: formatDate(selection.endDate),
        }
    }),
})
const getImportProfileStageDisciplineSignature = selections => JSON.stringify(
    importProfileSections.map(section => {
        const selection = selections?.[section.key] || {}
        const disciplineIds = Array.isArray(selection.disciplineIds)
            ? selection.disciplineIds.map(String).sort()
            : []

        return {
            stage: String(selection.stage ?? ''),
            disciplineIds,
        }
    })
)
const useStyle = (theme) => ({
    customGridStyle: {
        margin: 0,
        paddingRight: '8px',
        paddingLeft: '16px',
        marginBottom: '16px'
    },
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 300,
        width: "calc(100% - 20px)"
    },
    rows: {
        backgroundColor: "#EDFAFF",
    },
    leftSticky: {
        width: '165px',
        minWidth: '165px',
        maxWidth: '165px',
        zIndex: 10,
        left: 0,
        background: "#F8F8F8",
        textAlign: "center",
        boxSizing: 'border-box',
        position: 'sticky'
    },
    leftStickyHeader: {
        width: '165px',
        minWidth: '165px',
        maxWidth: '165px',
        zIndex: 1100,
        left: 0,
        top: 0,
        background: "#F8F8F8",
        textAlign: "center",
        boxSizing: 'border-box',
        position: 'sticky'
    }
})

// const validQty = [0.2, 0.4, 0.5, 0.6, 0.8, 1]

class PRPTemplate extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.empTableRef = React.createRef()
        this.state = {
            columns: [],
            data: [],
            copyData: [],
            zoom: 0.9,
            selectedOpportunity: null,
            weekDateRange: [],
            start_date: '',
            subTableCol: [],
            subTabledata: [],
            showDialog: false,
            selectedRole: {},
            selectedEmployee: {},
            modelOpen: false,
            roles: [],
            rolesObj: {},
            rolesToPost: "",
            isLoading: true,
            allEmp: [],
            allEmpObj: {},
            reviewModal: false,
            dataToUpload: [],
            dropZoneModal: false,
            reviewTableCol: [],
            reviewTableData: [],
            newRoles: [],
            disciplineArr: [],
            disciplineObj: {},
            discipline: '',
            owner_delivery_unit: {},
            owner_region: {},
            sector: {},
            sortByRoles: [
                // { id: 117 },
                // { id: 3 },
                // { id: 2 },
            ],
            totalCountType: false,
            rowDelete: false,
            deleteRowData: [],
            deleteRowIndex: [],
            deleteDisabled: true,
            deleteDisabled1: false,
            addDisabled: false,
            multipleSelect: false,
            assignDisabled: true,
            workType: [],
            linkedWorkType: [],
            selectedEmployees: [],
            customQtyValues: [],
            singleCustomQtyValues: [],
            singleShowDialog: false,
            type: null,
            addQtyDisbaled: false,
            deleteQtyID: [],
            allocationDialogSize: 'md',
            allocationDialog: false,
            role: null,
            addResource: false,
            scrollTop: false,
            openedRows: [],
            openedRowIds: {},
            roleGroups: [],
            selectedRoleGroup: null,
            tabValue: 0,
            addRoleDisabled: true,
            addEmployeeDisabled: true,
            bulkUploadDisabled: false,
            deletedQty: {},
            coffeeLoading: false,
            deletedQtyValues: false,
            tabChangeAlert: false,
            selectedTabValue: null,
            selectedIndex: null,
            selectedElement: null,
            editDescipline: false,
            selectedDiscipline: null,
            disciplineDropdown: [],
            selectedUser: {},
            empIsArchived: false,
            projectDetails: null,
            buttonDisabled: true,
            missingValues: {},
            workTypeObj: {},
            allCheck: false,
            dateDialog: false,
            bulkDates: { start_date: null, end_date: null },
            roleScheduleData: [],
            bulkDisplaySelectedRowIds: [],
            bulkDisplayExpandedRowIds: [],
            importProfileOpen: false,
            importProfileStep: 0,
            resourceProfileOpen: false,
            resourceProfileLoading: false,
            isSubmittingResourceProfile: false,
            resourceProfileTab: 0,
            resourceProfileDisciplineTab: 0,
            importProfileSelections: buildImportProfileSelections(null),
            importProfileInitialSelections: buildImportProfileSelections(null),
            isSavingImportProfile: false,
            stageGate: [],
            importProfileData: [],
            selectedImportProfileRow: []
        }
        this.isUnmounted = false
        this.xlsxLib = null
        this.requestControllers = new Set()
        this.templateRefreshInFlight = false
        this.templateRefreshQueued = false
        this.lastAllDatesKey = null
        this.topRef = createRef()
        this.handleReload = this.handleReload.bind(this)
        this.handleReset = this.handleReset.bind(this)
        this.handleDisabled = this.handleDisabled.bind(this)
        this.handleSelectedData = this.handleSelectedData.bind(this)
        this.handleRowData = this.handleRowData.bind(this)
        this.handleOpenDialog = this.handleOpenDialog.bind(this)
        this.getDialogSize = this.getDialogSize.bind(this)
        this.getSingleRoleData = this.getSingleRoleData.bind(this)
        this.increaseDialogSize = this.increaseDialogSize.bind(this)
        this.decreaseDialogSize = this.decreaseDialogSize.bind(this)
        this.removeEmployeewithoutReload = this.removeEmployeewithoutReload.bind(this)
        this.tabChangeAlert = this.tabChangeAlert.bind(this)
        this.handleLinkedWorkTypeRole = this.handleLinkedWorkTypeRole.bind(this)
        this.handleProjectType = this.handleProjectType.bind(this)
    }

    handleProjectType = (row, stageData, selectionScopeKey) => {
        let dataObj = {
            ...row,
            'stageData': stageData,
            selectionScopeKey,
        }
        this.setState(prev => ({
            selectedImportProfileRow: [
                ...prev.selectedImportProfileRow.filter(selection => selection.selectionScopeKey !== selectionScopeKey),
                dataObj,
            ],
        }))
    }


    handleLinkedWorkTypeRole = (row) => {
        let res = []
        let workType = this.state.workType
        for (let index = 0; index < workType.length; index++) {
            const element = workType[index];
            if (element.linked_role_ids.length !== 0) {
                for (let index = 0; index < element.linked_role_ids.length; index++) {
                    const element1 = element.linked_role_ids[index];
                    if (element1.role_id === row.role_id) {
                        res.push(element)
                    }
                }
            }
        }
        this.setState({
            linkedWorkType: res
        })
    }

    openImportProfile = () => {
        const selections = buildImportProfileSelections(this.state.projectDetails)
        this.setState({
            importProfileOpen: true,
            importProfileStep: 0,
            importProfileSelections: selections,
            importProfileInitialSelections: selections,
        })
    }

    loadResourceProfile = () => {
        const stageDisciplineData = importProfileSections.reduce((data, section) => {
            const selection = this.state.importProfileSelections[section.key]
            const selectedStage = this.state.stageGate.find(stage => String(stage.id) === String(selection.stage))
            if (!selectedStage || !selection.disciplineIds.length) return data

            data.push({
                type: section.label,
                stage_id: selectedStage.id,
                descipline_id: selection.disciplineIds.map(Number),
            })
            return data
        }, [])

        if (!stageDisciplineData.length) {
            this.props.enqueueSnackbar('Select a stage and at least one discipline.', {
                variant: 'warning'
            })
            return false
        }

        this.setState({
            resourceProfileOpen: false,
            resourceProfileLoading: true,
            resourceProfileTab: 0,
            resourceProfileDisciplineTab: 0,
            importProfileData: [],
            selectedImportProfileRow: [],
        })
        Service.post('/api/crm/get_stage_descipline_resource_profile_data/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                crm_id: this.state.projectDetails?.crm_id,
                data: stageDisciplineData
            },
        })
            .then(res => {
                if (!Array.isArray(res.data)) {
                    throw new Error('Unexpected resource profile response format.')
                }
                const defaultSelections = []
                res.data.forEach((profile, profileIndex) => {
                    const profileStageData = importProfileSections.find(section =>
                        section.label.toLowerCase() === String(profile?.type || '').toLowerCase()
                    ) || importProfileSections[profileIndex]
                    const disciplines = Array.isArray(profile?.descipline) ? profile.descipline : []

                    disciplines.forEach((discipline, disciplineIndex) => {
                        const defaultRow = Array.isArray(discipline?.resource_profile_data)
                            ? discipline.resource_profile_data.find(row => row?.default === true)
                            : null
                        if (!defaultRow) return

                        defaultSelections.push({
                            ...defaultRow,
                            stageData: profileStageData,
                            selectionScopeKey: `${profileStageData?.key || profile?.type || profileIndex}:${discipline?.descipline_id ?? disciplineIndex}`,
                        })
                    })
                })
                this.setState({
                    importProfileData: res.data,
                    selectedImportProfileRow: defaultSelections,
                    resourceProfileLoading: false,
                })
                this.props.enqueueSnackbar('Resource profile data loaded successfully.', {
                    variant: 'success'
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({ resourceProfileLoading: false })
                this.props.enqueueSnackbar('Unable to load resource profile data.', {
                    variant: 'error'
                })
            })

        return true
    }

    saveImportProfileAndContinue = (nextStep = 2) => {
        if (this.state.isSavingImportProfile) return

        const selections = this.state.importProfileSelections

        if (this.state.importProfileStep === 1) {
            if (!this.loadResourceProfile()) return

            this.setState({
                importProfileStep: nextStep,
            })
            return
        }

        const stageDates = importProfileSections.reduce((dates, section) => ({
            ...dates,
            [section.startDateKey]: moment(selections[section.key].startDate).format('YYYY-MM-DD'),
            [section.endDateKey]: moment(selections[section.key].endDate).format('YYYY-MM-DD'),
        }), {})

        this.setState({ isSavingImportProfile: true })
        Service.patch('/api/crm/update_crm_stage_dates/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                id: this.props.project.id,
                contract_award_value: Number(selections.contractAwardValue),
                ...stageDates,
            },
        })
            .then(() => {
                this.setState({
                    importProfileStep: nextStep,
                    importProfileInitialSelections: selections,
                    isSavingImportProfile: false,
                })
                this.props.enqueueSnackbar('Profile details saved successfully.', {
                    variant: 'success'
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({ isSavingImportProfile: false })
                this.props.enqueueSnackbar('Unable to save profile details.', {
                    variant: 'error'
                })
            })
    }

    closeImportProfile = () => {
        this.setState({ importProfileOpen: false, importProfileStep: 0 })
    }

    updateImportProfileSelection = (sectionKey, field, value) => {
        this.setState(previousState => ({
            importProfileSelections: {
                ...previousState.importProfileSelections,
                [sectionKey]: {
                    ...previousState.importProfileSelections[sectionKey],
                    [field]: value,
                },
            },
        }))
    }

    formatImportProfileDate = value => value ? moment(value).format('DD/MM/YYYY') : 'Not set'

    getUpdatedInfoText = (item, fallbackUpdatedInfo = '') => {
        if (item?.updated_info) {
            return item.updated_info
        }

        const updatedBy = item?.updated_by || 'N/A'
        const rawDate = item?.updated_on || 'N/A'
        const formattedDate = rawDate && moment(rawDate).isValid() ? moment(rawDate).format('DD-MM-YYYY HH:mm') : 'N/A'
        if (updatedBy !== 'N/A' || formattedDate !== 'N/A') {
            return `Name: ${updatedBy}\nDate: ${formattedDate}`
        }

        return fallbackUpdatedInfo || 'Name: N/A\nDate: N/A'
    }

    normalizeRoleUpdatedInfo = (roleObj, previousRole = null) => {
        const normalizedRole = { ...roleObj }
        normalizedRole.updated_info = this.getUpdatedInfoText(normalizedRole, previousRole?.updated_info || '')

        const previousEmployeeUpdatedInfoById = Array.isArray(previousRole?.prp_role)
            ? previousRole.prp_role.reduce((acc, item) => {
                if (item?.id) {
                    acc[item.id] = item.updated_info || ''
                }
                return acc
            }, {})
            : {}

        if (Array.isArray(normalizedRole.prp_role)) {
            normalizedRole.prp_role = normalizedRole.prp_role.map((employeeRole) => ({
                ...employeeRole,
                updated_info: this.getUpdatedInfoText(employeeRole, previousEmployeeUpdatedInfoById[employeeRole.id])
            }))
        }

        return normalizedRole
    }

    getOpenedRowsState = (rows = [], persistedIds = null) => {
        let idsFromStorage = persistedIds
        if (!Array.isArray(idsFromStorage)) {
            try {
                const rawValue = localStorage.getItem("openedRows")
                idsFromStorage = rawValue ? JSON.parse(rawValue) : []
            } catch (error) {
                idsFromStorage = []
            }
        }
        idsFromStorage = idsFromStorage.length > 0 ? [idsFromStorage[0]] : []

        const rowIdSet = new Set((rows || []).map((row) => String(row.id)))
        const openedRowIds = {}
        const openedRows = []
        idsFromStorage.forEach((id) => {
            const key = String(id)
            if (rowIdSet.has(key)) {
                openedRowIds[key] = true
                openedRows.push(Number(id))
            }
        })

        return { openedRowIds, openedRows }
    }

    isRowOpen = (rowId) => {
        return Boolean(this.state.openedRowIds[String(rowId)])
    }

    toggleRowOpen = (rowId) => {
        const key = String(rowId)
        this.setState((prevState) => {
            const isCurrentlyOpen = Boolean(prevState.openedRowIds && prevState.openedRowIds[key])
            const openedRowIds = isCurrentlyOpen ? {} : { [key]: true }
            const openedRows = isCurrentlyOpen ? [] : [Number(rowId)]
            return { openedRowIds, openedRows }
        }, () => {
            localStorage.setItem("openedRows", JSON.stringify(this.state.openedRows))
        })
    }

    preserveOpenedRowForReload = (preferredRowId = null) => {
        const rowId = preferredRowId !== null && preferredRowId !== undefined
            ? Number(preferredRowId)
            : (Array.isArray(this.state.openedRows) && this.state.openedRows.length > 0 ? Number(this.state.openedRows[0]) : null)

        if (rowId === null || Number.isNaN(rowId)) {
            return
        }

        const openedRows = [rowId]
        const openedRowIds = { [String(rowId)]: true }
        localStorage.setItem("openedRows", JSON.stringify(openedRows))
        this.setState({ openedRows, openedRowIds })
    }

    getXlsxLib = async () => {
        if (this.xlsxLib) {
            return this.xlsxLib
        }
        const xlsxModule = await import("xlsx")
        this.xlsxLib = xlsxModule.default || xlsxModule
        return this.xlsxLib
    }

    createRequestController = () => {
        if (typeof AbortController === 'undefined') {
            return null
        }
        const controller = new AbortController()
        this.requestControllers.add(controller)
        return controller
    }

    clearRequestController = (controller) => {
        if (controller) {
            this.requestControllers.delete(controller)
        }
    }

    cancelPendingRequests = () => {
        this.requestControllers.forEach((controller) => {
            try {
                controller.abort()
            } catch (error) {
                // no-op
            }
        })
        this.requestControllers.clear()
    }

    getDiscipline() {
        Service.get(`/api/subsector/get_with_delete_status/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    disciplineDropdown: res.data
                })
            }).catch(error => {
                this.props.enqueueSnackbar('Something went wrong.', {
                    variant: 'error'
                })
            })
    }

    componentDidMount() {
        this.isUnmounted = false
        this.prefetchData()
    }

    componentWillUnmount() {
        this.isUnmounted = true
        this.cancelPendingRequests()
        localStorage.removeItem("searchKey")
        localStorage.removeItem("openedRows")
        localStorage.removeItem("selectedRoleGroup")
    }

    getDiscipline = (signal) => {
        return new Promise((resolve, reject) => {
            Service.get('/api/subsector/get_with_delete_status/', {
                signal,
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => reject(error))
        })
    }

    getWorkType = (signal) => {
        return new Promise((resolve, reject) => {
            Service.get('/api/role/worktype/role_work_type_link/', {
                signal,
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => reject(error))
        })
    }

    getStages = (signal) => {
        return new Promise((resolve, reject) => {
            Service.get('/api/resource/profile/stage/get_resource_profile_stage_data/', {
                signal,
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => reject(error))
        })
    }

    prefetchData = () => {
        const controller = this.createRequestController()
        const signal = controller ? controller.signal : undefined
        Promise.all([
            getSubSector(),
            this.getEmployeesData(signal),
            getActiveRoles(),
            getRoleGroups(),
            this.getDiscipline(signal),
            this.getWorkType(signal),
            this.getStages()
            // /api/resource/profile/stage/get_resource_profile_stage_data/
        ])
            .then(res => {
                this.clearRequestController(controller)
                if (this.isUnmounted) {
                    return
                }
                var disciplineObj = getLookupObj(res[0])
                var disciplineArr = res[0]
                var allEmpObj = {}
                var allEmpRoleObj = {}
                var workTypeObj = {}
                res[1].forEach(ele => {
                    allEmpObj[ele.id] = ele.first_name + " " + ele.last_name
                    allEmpRoleObj[ele.id] = ele.job_title
                })
                res[5].forEach(ele => {
                    workTypeObj[ele.id] = ele.name
                })
                const roleGroups = [...res[3]].sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }))

                this.setState({
                    disciplineObj,
                    disciplineArr,
                    allEmp: getDataIsdeletedFalse(res[1]),
                    allEmpObj: allEmpObj,
                    allEmpRoleObj,
                    addRoleDisabled: false,
                    addEmployeeDisabled: false,
                    selectedOpportunity: this.props.project,
                    roles: res[2],
                    rolesObj: getRolesLookupObj(res[2]),
                    roleGroups,
                    disciplineDropdown: res[4],
                    workType: res[5],
                    workTypeObj: workTypeObj,
                    stageGate: res[6]
                }, () => {
                    if (this.empTableRef && this.empTableRef.current) {
                        this.empTableRef.current.disableEmpButton(false)
                    }
                    this.getData()
                })
            })
            .catch(e => {
                this.clearRequestController(controller)
                if (this.isUnmounted) {
                    return
                }
                console.log(e)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                })
            })
    }

    getDialogSize = (size) => {
        this.setState({ allocationDialogSize: size })
    }

    refreshRoleAfterAllocation = (prpTempId) => {
        if (!prpTempId) {
            this.handleReload()
            return
        }

        const controller = this.createRequestController()
        Service.get(`/api/prp/template/get_secured_with_role/?crm=${this.props.project.id}&prp_temp=${prpTempId}`, {
            signal: controller ? controller.signal : undefined,
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then((res) => {
                this.clearRequestController(controller)
                if (this.isUnmounted) {
                    return
                }
                if (res && res.data) {
                    this.getSingleRoleData(res.data)
                    return
                }
                this.handleReload()
            })
            .catch((error) => {
                this.clearRequestController(controller)
                if (this.isUnmounted) {
                    return
                }
                console.log(error)
                this.handleReload()
            })
    }

    closeDialog = (shouldRefresh = false) => {
        const activeTab = this.state.tabValue
        const isAddResourceFlow = this.state.addResource
        const selectedPrpTemplateId = this.state.role?.id || this.state.selectedUser?.id
        const shouldUseRoleRefresh = (activeTab === 0 || isAddResourceFlow) && Boolean(selectedPrpTemplateId)

        this.setState({ allocationDialog: false, allocationDialogSize: "md", addResource: false, tabValue: 0 }, () => {
            if (shouldRefresh) {
                this.handleReload()
                return
            }
            if (shouldUseRoleRefresh) {
                this.refreshRoleAfterAllocation(selectedPrpTemplateId)
                return
            }
            this.handleReload()
        })
    }

    handleRowData(data) {
        const shdlData = Array.isArray(data?.shdl_data) ? data.shdl_data.map((item) => ({ ...item })) : []
        const empData = {
            ...data,
            shdl_data: shdlData.map((item) => ({ ...item }))
        }
        this.setState({
            empIsArchived: empData.emp_is_archived,
            singleCustomQtyValues: shdlData,
            selectedEmployee: empData,
            type: empData.type
        })
    }

    handleOpenDialog() {
        this.setState({ singleShowDialog: true })
    }

    handleReload(preferredRowId = null) {
        this.preserveOpenedRowForReload(preferredRowId)
        if (this.templateRefreshInFlight) {
            this.templateRefreshQueued = true
            return
        }
        this.getPRPtemplate()
    }

    handleReset() {
        this.setState({
            multipleSelect: false,
            assignDisabled: true
        })
    }

    isAssignDisabledForSelection = (selectedEmployees = []) => {
        const selectedRoleIds = new Set(
            selectedEmployees
                .filter((emp) => emp && emp.role_id !== undefined && emp.role_id !== null)
                .map((emp) => emp.role_id)
        )
        return selectedRoleIds.size !== 1
    }

    handleSelectedData(data) {
        let selectedEmployees = [...this.state.selectedEmployees]
        if (data.is_checked) {
            const exists = selectedEmployees.some((emp) => emp.id === data.id)
            if (!exists) {
                selectedEmployees.push(data)
            }
        } else {
            selectedEmployees = selectedEmployees.filter((emp) => emp.id !== data.id)
        }

        const syncParentFromNested = (rows) => rows.map((item) => {
            if (!Array.isArray(item.prp_role)) return item
            const hasNested = item.prp_role.some((roleItem) => roleItem.id === data.id)
            if (!hasNested) return item
            const updatedPrpRole = item.prp_role.map((roleItem) => (
                roleItem.id === data.id ? { ...roleItem, is_checked: data.is_checked } : roleItem
            ))
            const isChecked = updatedPrpRole.length > 0 && updatedPrpRole.every((roleItem) => Boolean(roleItem.is_checked))
            return {
                ...item,
                prp_role: updatedPrpRole,
                isChecked
            }
        })

        const dataRows = syncParentFromNested([...this.state.data])
        const copyData = syncParentFromNested([...this.state.copyData])
        const deleteRowData = copyData.filter((item) => item.isChecked)
        const deleteRowIndex = deleteRowData.map((item) => item.id)
        const filteredData = this.getRoleGroupFilteredRows(dataRows)
        const allCheck = filteredData.length > 0 && filteredData.every((item) => item.isChecked)

        this.setState({
            data: dataRows,
            copyData,
            selectedEmployees,
            deleteRowData,
            deleteRowIndex,
            allCheck,
            deleteDisabled: deleteRowData.length === 0,
            assignDisabled: this.isAssignDisabledForSelection(selectedEmployees)
        }, () => {
            let customQtyValues = []
            for (let i = 0; i < selectedEmployees.length; i++) {
                const element = selectedEmployees[i];
                if (customQtyValues.length === 0) {
                    let shdl_data = []
                    for (let l = 0; l < element.shdl_data.length; l++) {
                        const ite = element.shdl_data[l];
                        if (ite.from_date && ite.to_date) {
                            ite['from'] = new Date(ite.from_date)
                            ite['to'] = new Date(ite.to_date)
                            shdl_data.push(ite)
                        } else {
                            shdl_data.push({ from: this.props.project.contractor_start_date, to: this.props.project.contractor_end_date, qty: 0 })
                        }
                    }
                    customQtyValues.push({
                        role_id: element.role_id,
                        type: element.type,
                        shdl_data: shdl_data
                    })
                } else {
                    let found = customQtyValues.find(ele => ele.role_id === element.role_id)
                    if (found) {
                        let shdl_data = found.shdl_data
                        for (let k = 0; k < element.shdl_data.length; k++) {
                            const item = element.shdl_data[k];
                            if (item.from_date && item.to_date) {
                                item['from'] = new Date(item.from_date)
                                item['to'] = new Date(item.to_date)
                                shdl_data.push(item)
                            } else {
                                shdl_data.push({ from: this.props.project.contractor_start_date, to: this.props.project.contractor_end_date, qty: 0 })
                            }
                            found.shdl_data = shdl_data
                        }
                    } else {
                        let shdl_data = []
                        for (let j = 0; j < element.shdl_data.length; j++) {
                            const item = element.shdl_data[j];
                            if (item.from_date && item.to_date) {
                                item['from'] = new Date(item.from_date)
                                item['to'] = new Date(item.to_date)
                                shdl_data.push(item)
                            } else {
                                shdl_data.push({ from: this.props.project.contractor_start_date, to: this.props.project.contractor_end_date, qty: 0 })
                            }
                        }
                        customQtyValues.push({
                            role_id: element.role_id,
                            type: element.type,
                            shdl_data: shdl_data
                        })
                    }
                }
            }
            this.setState({ customQtyValues: customQtyValues })
        })
    }

    getEmployeesData = (signal) => {
        return new Promise((resolve, reject) => {
            Service.get('/api/ptd/employees/get_emp_data/', {
                signal,
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => reject(error))
        })
    }

    getData() {
        // this.getBulkData()
        this.getPRPtemplate()
    }

    getBulkData() {
        Service.get(`/api/role/schedule/get_template_role_schedule/?role_schedule_ids=${54375}&start_date=${'2026-02-02'}&end_date=${'2026-02-09'}`, {
            headers: {
                Authorization: "Token " + token,
            },

        })
            .then(res => {

            }).catch(error => {
                this.setState({ rowDelete: false, isLoading: false, deleteDisabled1: false }, () =>
                    this.props.enqueueSnackbar('Roles deletion failed.', {
                        variant: 'error'
                    }))
            })
    }

    handleDisabled(childData) {
        this.setState((prevState) => ({
            assignDisabled: this.isAssignDisabledForSelection(prevState.selectedEmployees) ? true : childData
        }))
    }

    getPRPtemplate = () => {
        if (this.templateRefreshInFlight) {
            this.templateRefreshQueued = true
            return
        }

        this.templateRefreshInFlight = true
        const controller = this.createRequestController()
        this.setState({ isLoading: true })
        Service.get("/api/prp/template/secured/?crm=" + this.props.project.id, {
            signal: controller ? controller.signal : undefined,
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.clearRequestController(controller)
                if (this.isUnmounted) {
                    return
                }
                let prptArray = getDataIsdeletedFalse(res.data.roles);

                const allDates = Array.isArray(res.data?.all_dates) ? res.data.all_dates : []
                const allDatesKey = allDates.join('|')
                if (this.lastAllDatesKey !== allDatesKey) {
                    this.lastAllDatesKey = allDatesKey
                    this.setColumns(res.data)
                }

                this.prpData = prptArray;
                const previousRoleById = this.state.copyData.reduce((acc, roleItem) => {
                    if (roleItem?.id) {
                        acc[roleItem.id] = roleItem
                    }
                    return acc
                }, {})
                const sorted = prptArray.map((prptObj) => {
                    const normalizedRole = this.normalizeRoleUpdatedInfo(prptObj, previousRoleById[prptObj.id])
                    let dates = {}
                    let prptEmpArray = normalizedRole.prp_role
                    let allEmpRoleObj = {}
                    prptEmpArray.forEach(empEle => {
                        allEmpRoleObj[empEle.id] = empEle.job_title
                    })

                    let set = []
                    for (const item in dates) {
                        set.push(item)
                    }
                    let sorted = set.sort(function (a, b) {
                        // sorts the dates array
                        a = a.toString().split('/');
                        b = b.toString().split('/');
                        return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
                    });

                    let st_en_date = { start_date: sorted[0], end_date: sorted[sorted.length - 1] }
                    dates = {
                        ...dates,
                        ...normalizedRole,
                        ...st_en_date,
                    }
                    return dates
                })

                sorted.forEach((item) => item.isChecked = false)
                sorted.forEach((item) => item.editDescipline = false)
                for (let index = 0; index < sorted.length; index++) {
                    const element = sorted[index];
                    for (let index = 0; index < element.prp_role.length; index++) {
                        const element1 = element.prp_role[index];
                        element1.descipline = element.descipline
                    }
                }
                let selectedRoleGroup = null
                try {
                    const persistedRoleGroup = localStorage.getItem('selectedRoleGroup')
                    selectedRoleGroup = persistedRoleGroup ? JSON.parse(persistedRoleGroup) : null
                } catch (error) {
                    selectedRoleGroup = null
                }
                const { openedRows, openedRowIds } = this.getOpenedRowsState(sorted)
                localStorage.setItem("openedRows", JSON.stringify(openedRows))
                this.setState({ data: sorted, isLoading: false, copyData: sorted, singleShowDialog: false, deleteQtyID: [], deletedQtyValues: false, projectDetails: res.data, selectedRoleGroup, openedRows, openedRowIds }, () => {
                    if (localStorage.getItem("searchKey")) {
                        this.handleSearchChange(localStorage.getItem("searchKey"))
                    }
                })
                this.copyOfData = sorted
                // }, 1000);
            }).catch(error => {
                this.clearRequestController(controller)
                if (this.isUnmounted) {
                    return
                }
                console.log(error)
                this.setState({ isLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                })
            }).finally(() => {
                this.templateRefreshInFlight = false
                if (this.templateRefreshQueued && !this.isUnmounted) {
                    this.templateRefreshQueued = false
                    this.getPRPtemplate()
                }
            })
    }

    openDialog = () => {
        this.setState({ showDialog: true })
    }

    closeShowDialog = () => {
        this.setState({ showDialog: false })
    }

    closeSingleDialog = () => {
        this.setState({ singleShowDialog: false, deleteQtyID: [] }, () => {
            if (this.state.deletedQtyValues) {
                this.handleReload()
            }
        })
    }

    openSingleDialog = () => {
        this.setState({ singleShowDialog: true })
    }

    setColumns(data) {
        let column = [
            {
                title: "Role",
                field: "role_name",
                // lookup: this.state.rolesObj,
                headerStyle: {
                    width: "120px", minWidth: "120px", maxWidth: "120px", boxSizing: "border-box", zIndex: 999,
                    left: '165px',
                    background: "#F8F8F8",
                    position: "sticky"
                },
                columnStyle: {
                    width: "120px", minWidth: "120px", maxWidth: "120px", boxSizing: "border-box", zIndex: 99,
                    left: '165px',
                    background: "#F8F8F8",
                    position: "sticky",
                    fontWeight: 'bold'
                },
                cellStyle: { width: "120px", minWidth: "120px", maxWidth: "120px", boxSizing: "border-box" },
            }, {
                title: "Discipline",
                field: "descipline",
                lookup: this.state.disciplineObj,
                headerStyle: {
                    width: '100px', minWidth: '100px', maxWidth: '100px', boxSizing: 'border-box', zIndex: 1000,
                    background: "#F8F8F8",
                    left: '285px',
                    position: "sticky",
                    boxShadow: "1px 2px 1px #F8F8F8",
                    fontWeight: 'bold'
                },
                columnStyle: {
                    width: '100px', minWidth: '100px', maxWidth: '100px', boxSizing: 'border-box', zIndex: 100,
                    background: "#F8F8F8",
                    left: '285px',
                    position: "sticky",
                    boxShadow: "1px 2px 1px #F8F8F8",
                    fontWeight: 'bold'
                },
                cellStyle: { width: '100px', minWidth: '100px', maxWidth: '100px', boxSizing: 'border-box' },
            }, {
                title: 'Updated Info',
                field: 'updated_info',
                width: 170,
                filtering: false,
                headerStyle: { width: "170px", minWidth: "170px", maxWidth: "170px", boxSizing: "border-box" },
                columnStyle: { width: "170px", minWidth: "170px", maxWidth: "170px", boxSizing: "border-box" },
                cellStyle: { whiteSpace: 'pre-line', width: "170px", minWidth: "170px", maxWidth: "170px", boxSizing: "border-box" },
            }, {
                title: "Project Total",
                field: "project_total",
                type: "numeric",
                width: 80,
                filtering: false,
                headerStyle: { width: "100px" },
            }, {
                title: "Tender Total",
                field: "tender_total",
                type: "numeric",
                width: 80,
                filtering: false,
                headerStyle: { width: "100px" },
            }, {
                title: "Start Date",
                field: "min_start_date",
                type: "date",
                width: 100,
                filtering: false,
                headerStyle: { width: "100px", minWidth: "100px", maxWidth: "100px", boxSizing: "border-box" },
                columnStyle: { width: "100px", minWidth: "100px", maxWidth: "100px", boxSizing: "border-box" },
            }, {
                title: "End Date",
                field: "max_end_date",
                type: "date",
                width: 100,
                filtering: false,
                headerStyle: { width: "100px", minWidth: "100px", maxWidth: "100px", boxSizing: "border-box" },
                columnStyle: { width: "100px", minWidth: "100px", maxWidth: "100px", boxSizing: "border-box" },
            },
        ];

        let reviewTableColumn = [
            {
                title: "Role",
                field: "role",
                width: 100,
                lookup: this.state.rolesObj,
                headerStyle: { minWidth: "200px" },
                cellStyle: { minWidth: "200px" },
            },
            {
                title: "Discipline",
                field: "descipline",
                width: 100,
                lookup: this.state.disciplineObj,
            },
            {
                title: "Employee",
                field: "emp_id",
                width: 100,
                lookup: this.state.allEmpObj,
            },
            {
                title: 'Work Type',
                field: 'work_type',
                width: 100,
            },
            {
                title: "Type",
                field: "type",
                width: 100,
                lookup: { 1: "Project", 2: "Tender" },
            },
        ];

        let subTableCol = [
            // { title: "", field: "" },
            // { title: "", field: "" },
            {
                title: <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ color: getPrimaryColor() }}>Employee</div><div>&nbsp;</div><div>/</div><div>&nbsp;</div><div style={{ color: getSecondaryColor() }}> SubContractor</div>
                </div>,
                field: "emp_id",
                width: 100,
                // lookup: this.state.allEmpObj,
                render: (rowData) => rowData.emp_first_name || rowData.emp_last_name ? <b style={{ color: getPrimaryColor() }}>{rowData.emp_first_name + ' ' + rowData.emp_last_name}</b> : rowData.subcontractor_company_name ? <b style={{ color: getSecondaryColor() }}>{rowData.subcontractor_company_name}</b> : rowData.atr_bbuk_number ? <b style={{ color: '#000' }}>{rowData.atr_bbuk_number}</b> : null,
                headerStyle: {
                    width: "100px", zIndex: 99, position: "sticky",
                    left: '120px',
                    background: "#F8F8F8",
                },
            },
            {
                title: 'Updated Info',
                field: 'updated_info',
                width: 170,
                filtering: false,
                headerStyle: { width: "170px", minWidth: "170px", maxWidth: "170px", boxSizing: "border-box" },
                cellStyle: { whiteSpace: 'pre-line', width: "170px", minWidth: "170px", maxWidth: "170px", boxSizing: "border-box" },
            },
            {
                title: "Type",
                field: "type",
                width: 100,
                lookup: { 1: "Project", 2: "Tender" },
                filtering: false,
                headerStyle: { width: "100px" },
            },
            {
                title: "Total weeks",
                field: "total_weeks",
                width: 400,
                type: "numeric",
                filtering: false,
                headerStyle: { width: "100px" },
            },
            {
                title: "Start Date",
                field: "start_date",
                type: "date",
                width: 100,
                editable: "never",
                filtering: false,
                headerStyle: { width: "100px" },
                editComponent: (props) => (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                            // autoOk
                            clearable
                            format="dd.MM.yyyy"
                            minDate={data.contractor_start_date}
                            maxDate={data.contractor_end_date}
                            emptyLabel=""
                            value={props.value ? props.value : data.contractor_start_date}
                            onChange={(e) => props.onChange(e)}
                        />
                    </MuiPickersUtilsProvider>
                ),
            },
            {
                title: "End Date",
                field: "end_date",
                type: "date",
                width: 100,
                editable: "never",
                filtering: false,
                headerStyle: { width: "100px" },
                editComponent: (props) => (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                            // autoOk
                            clearable
                            format="dd.MM.yyyy"
                            minDate={data.contractor_start_date}
                            maxDate={data.contractor_end_date}
                            emptyLabel=""
                            value={props.value ? props.value : data.contractor_end_date}
                            onChange={(e) => props.onChange(e)}
                        />
                    </MuiPickersUtilsProvider>
                ),
            },
        ];

        // Keep weekly columns bounded for long-duration projects to avoid huge DOM/memory usage.
        const allDates = Array.isArray(data?.all_dates) ? data.all_dates : []

        this.setState({ weekDateRange: allDates })

        allDates.forEach((date) => {
            let newObj = {
                title: date,
                field: date,
                type: "numeric",
                sorting: false,
                headerStyle: {
                    // transform: "rotate(270deg)",
                    width: '50px',
                    textAlign: "center",
                },
                cellStyle: {
                    textAlign: "center",
                },
                editable: "never",
                filtering: false,

            };
            column.push(newObj);
            subTableCol.push(newObj);
            reviewTableColumn.push(newObj);
        });
        this.setState({
            columns: column,
            subTableCol: subTableCol,
            reviewTableCol: reviewTableColumn,
        })
    }

    getWeekOfDates = (startDate, endDate) => {

        const dayINeed = 1; // for Monday

        var currDate = moment(startDate).startOf('day');
        var lastDate = moment(endDate).startOf('day');
        let dates = []
        while (currDate.diff(lastDate) <= 0) {
            if (
                currDate.isoWeekday() === dayINeed ||
                currDate.format('DD/MM/YYYY') === moment(startDate).startOf('day').format('DD/MM/YYYY')
            ) {
                dates.push(currDate.format('DD/MM/YYYY'));
            }
            currDate.add(1, 'days')
        }
        return dates
    }

    fillDatesWithQty = (dates, qty) => {
        let obj = {};
        dates.forEach(date => {
            obj[date] = qty
        })
        return obj;
    }

    handleZoom = (e, v) => {
        this.setState({ zoom: v })
    }

    decreaseZoom = () => {
        let zoom = (Number(this.state.zoom) - 0.1).toFixed(1);
        if (zoom < 0.5) return;
        this.setState({ zoom: zoom })

    }

    increaseZoom = () => {
        let zoom = (Number(this.state.zoom) + 0.1).toFixed(1);
        if (zoom > 1.2) return;
        this.setState({ zoom: zoom })
    }

    handleChange = (e) => {
        let { name, value } = e.target
        this.setState({ [name]: value })
    }

    addRole = (e, rowdata) => {
        this.handleClickOpen()
    }

    deleteAlert = () => {
        this.setState({ rowDelete: true })
    }

    deleteRole = () => {
        this.setState({ deleteDisabled: true, deleteDisabled1: true })
        let idsToDelete = []
        for (let i = 0; i < this.state.deleteRowData.length; i++) {
            const element = this.state.deleteRowData[i];
            if (element) {
                idsToDelete.push(element.id)
            }
        }
        if (idsToDelete.length > 0) {
            Service.get(`${prptandPrprDeleteByPRPtid}${idsToDelete.toString()}`, {
                headers: {
                    Authorization: "Token " + token,
                },

            })
                .then(res => {
                    let dupData = [...this.state.data]
                    let copyData = this.state.copyData.filter(ele => !idsToDelete.includes(ele.id))
                    let data = []
                    for (let i = 0; i < dupData.length; i++) {
                        const element = dupData[i];
                        if (!this.state.deleteRowIndex.includes(i)) {
                            data.push(element)
                        }
                    }

                    this.setState({ data: data, copyData, rowDelete: false, isLoading: false, deleteRowData: [], deleteRowIndex: [], deleteDisabled: true, deleteDisabled1: false, selectedEmployees: [] }, () => {
                        this.getData()
                        this.props.enqueueSnackbar('Roles deleted successfully.', {
                            variant: 'success'
                        })
                    })
                }).catch(error => {
                    this.setState({ rowDelete: false, isLoading: false, deleteDisabled1: false }, () =>
                        this.props.enqueueSnackbar('Roles deletion failed.', {
                            variant: 'error'
                        }))
                })
        } else {
            this.props.enqueueSnackbar('Please select the roles to delete!.', {
                variant: 'warning'
            })
        }
    }

    addRoleOps = () => {
        for (let i = 0; i < this.state.data.length; i++) {
            if (Number(this.state.data[i].role_id) === Number(this.state.rolesToPost)
                && Number(this.state.data[i].descipline) === Number(this.state.discipline)) {
                this.props.enqueueSnackbar('Role and Discipline is already added.', {
                    variant: 'warning'
                });
                return;
            }
        }
        this.setState({ addDisabled: true })
        Service.post('/api/prp/template/create_prptemplate/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                role: this.state.rolesToPost,
                descipline: this.state.discipline,
                crm: this.props.project.id
            }
        })
            .then(res => {
                this.setState({ addDisabled: false })
                this.handleClose();
                this.getPRPtemplate()
            }).catch(error => {
                console.log(error)
                if (error.status === 406) {
                    this.props.enqueueSnackbar('Role and Discipline is already added.', {
                        variant: 'warning'
                    });
                }
                this.setState({ addDisabled: false })
            })
    }

    handleClickOpen = () => { this.setState({ modelOpen: true }) }

    handleClose = () => { this.setState({ modelOpen: false }) }

    reviewModalOpen = () => { this.setState({ reviewModal: true }) }

    reviewModalClose = () => {
        this.setState({
            reviewModal: false,
            reviewTableData: [],
            uploadFormattedData: [],
            missingValues: {},
            buttonDisabled: true
        })
    }

    fileToRead(files) {
        if (!files || !files[0]) {
            this.setState({ buttonDisabled: true })
            return;
        }
        let f = files[0];
        if (f.size > MAX_UPLOAD_SIZE_BYTES) {
            this.props.enqueueSnackbar(`Upload file is too large. Please use a file under ${Math.floor(MAX_UPLOAD_SIZE_BYTES / (1024 * 1024))} MB.`, {
                variant: 'warning'
            })
            this.setState({ buttonDisabled: true })
            return
        }
        try {
            const reader = new FileReader();
            const rABS = !!reader.readAsBinaryString;

            reader.onload = async (e) => {
                try {
                    const XLSX = await this.getXlsxLib()

                    /* read workbook */
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: 'binary' });

                    /* grab first sheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    let missingValues = []
                    let headerDateCheck = false

                    /* save data */
                    let data = XLSX.utils.sheet_to_json(ws)
                    if (data.length > MAX_UPLOAD_ROWS) {
                        this.props.enqueueSnackbar(`Upload contains too many rows (${data.length}). Please keep it below ${MAX_UPLOAD_ROWS}.`, {
                            variant: 'warning'
                        })
                        this.setState({ buttonDisabled: true })
                        return
                    }
                    // Convert all keys in each row to lowercase
                    data = data.map(row => {
                        const newRow = {};
                        Object.keys(row).forEach(key => {
                            if (moment(key).isValid()) {
                                if (moment(key, ["D/M/YY", "DD/MM/YYYY", "M/D/YY"], true).isValid()) {
                                    headerDateCheck = true
                                    newRow[moment(key).format('MM/DD/YYYY')] = row[key];
                                } else {
                                    if (!missingValues.some(mv => mv.column === 'Dates' && mv.value === key)) {
                                        missingValues.push({
                                            column: 'Dates',
                                            value: key,
                                            message: 'Invalid date format in header. Please ensure all date columns are in DD/MM/YYYY format.'
                                        });
                                    }
                                    return
                                }
                            } else {
                                newRow[key.toLowerCase()] = row[key];
                            }
                        });
                        return newRow;
                    });

                    if (!headerDateCheck) {
                        missingValues.push({
                            column: 'Dates',
                            value: '',
                            message: 'No valid date format headers found. Please ensure all date columns are in DD/MM/YYYY format.'
                        });
                    }


                    data.forEach(ele => {

                        const isAvailableAlready = (value, availableObj, keyName) => {
                            let found = false
                            let foundElement = undefined
                            for (let element in availableObj) {
                                if (availableObj[element] === value) {
                                    found = true
                                    foundElement = keyName === 'Work Type' ? value : element
                                }
                            }
                            if (!found) {
                                if (value === null || value === undefined || value === '') {
                                    return null;
                                }
                                else if (!(missingValues[value])) {
                                    missingValues = { ...missingValues, [keyName]: value }
                                }
                            } else {
                                return foundElement;
                            }
                        }
                        ele.role = isAvailableAlready(ele.role, this.state.rolesObj, 'Role')
                        ele.work_type = isAvailableAlready(ele['work type'], this.state.workTypeObj, 'Work Type')
                        ele.descipline = isAvailableAlready(ele.discipline, this.state.disciplineObj, 'Discipline')

                        if (!Array.isArray(missingValues)) missingValues = [];
                        const rowIndex = data.indexOf(ele);
                        const getCellRef = (colName) => {
                            const headers = Object.keys(data[0]);
                            const colIndex = headers.indexOf(colName.toLowerCase());
                            if (colIndex === -1) return '';
                            let dividend = colIndex + 1;
                            let columnName = '';
                            while (dividend > 0) {
                                let modulo = (dividend - 1) % 26;
                                columnName = String.fromCharCode(65 + modulo) + columnName;
                                dividend = Math.floor((dividend - modulo) / 26);
                            }
                            return columnName + (rowIndex + 2);
                        };

                        if (!ele.role) {
                            missingValues.push({
                                row: rowIndex + 2,
                                column: 'Role',
                                cell: getCellRef('role'),
                                value: ele.role,
                                message: 'Role is missing or not valid. Expected a valid role name.'
                            });
                            ele.role = null;
                        }

                        if (ele.employee) {
                            for (let i = 0; i < this.state.allEmp.length; i++) {
                                if (this.state.allEmp[i].emp_no === `${ele.employee}`) {
                                    ele.employee = this.state.allEmp[i].id;
                                }
                            }
                        }

                        if (ele.type) {
                            if (String(ele.type).trim() === 'Project') {
                                ele.type = 1;
                            } else if (String(ele.type).trim() === 'Tender') {
                                ele.type = 2;
                            } else {
                                missingValues.push({
                                    row: rowIndex + 2,
                                    column: 'Type',
                                    cell: getCellRef('type'),
                                    value: ele.type,
                                    message: 'Type is not valid. It should be either Project or Tender.'
                                });
                                ele.type = null;
                            }
                        }

                        if (!ele.descipline || !ele.discipline) {
                            missingValues.push({
                                row: rowIndex + 2,
                                column: 'Discipline',
                                cell: getCellRef('discipline'),
                                value: ele.discipline,
                                message: 'Discipline is missing or not valid. Please ensure it matches exactly with one of the existing disciplines.'
                            });
                        }

                    })

                    if (this.isUnmounted) {
                        return
                    }

                    if (Object.keys(missingValues).length > 0) {
                        this.setState({
                            missingValues: missingValues
                        }, () => {
                            this.setState({
                                buttonDisabled: true,
                                warningDialog: true
                            })
                        })
                    } else {
                        this.makeUplodFormat(data)
                    }
                } catch (err) {
                    if (this.isUnmounted) {
                        return
                    }
                    this.props.enqueueSnackbar(err.message, { variant: 'error' })
                    this.dropzoneClose()
                    this.setState({ coffeeLoading: false })
                }
            };
            if (rABS) {
                reader.readAsBinaryString(f);
            } else {
                reader.readAsArrayBuffer(f);
            }
        }
        catch (err) {
            this.props.enqueueSnackbar(err.message, { variant: 'error' })
            this.dropzoneClose()
            this.setState({ coffeeLoading: false })
        }
    }

    makeUplodFormat(data) {
        const hasNonMondayDate = data.some((emp) => Object.keys(emp).some((key) => {
            const date = moment(key, 'MM/DD/YYYY', true)
            return date.isValid() && date.isoWeekday() !== 1
        }))

        if (hasNonMondayDate) {
            this.setState({ buttonDisabled: true })
            this.props.enqueueSnackbar('All date columns must be Mondays.', {
                variant: 'warning'
            })
            return
        }

        this.setState({
            buttonDisabled: false,
            disabledLoading: false
        })
        let newarr = [];
        let uploadFormattedData = [];
        data.forEach(emp => {
            let obj = {};
            obj.role = parseInt(emp.role);
            obj.emp_id = emp.employee
            // obj.descipline = parseInt(emp.discipline)
            obj.type = emp.type
            obj.role_key = emp.role_key
            obj = { ...obj, crm: this.props.project.id }
            let dates = []
            for (const ele in emp) {
                const date = moment(ele, 'MM/DD/YYYY', true)
                if (date.isValid() && emp[ele] > 0) {
                    dates.push({ date: date.format('DD/MM/YYYY'), qty: emp[ele] })
                }
            }
            let sorted = dates.sort(function (a, b) {
                a = a.date.toString().split('/');
                b = b.date.toString().split('/');
                return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
            });


            obj.work_type = emp.work_type ? emp.work_type : null;
            obj.descipline = emp.descipline ? emp.descipline : null;

            let shdlData = [];
            let fromDate = null;
            let rangeQty = null;

            sorted.forEach((ele, i) => {
                if (typeof ele.qty === 'string') {
                    ele.qty = parseFloat(ele.qty.trim());
                }
                obj.dates = { ...obj.dates, ...{ [ele.date]: ele.qty.toFixed(1) } }

                if (fromDate === null) fromDate = ele.date;
                if (rangeQty === null) rangeQty = ele.qty;

                const previousDate = sorted[i - 1]?.date
                const hasGapFromPrevious = previousDate ? moment(ele.date, 'DD/MM/YYYY').diff(moment(previousDate, 'DD/MM/YYYY'), 'weeks', true) > 1 : false
                const shouldClosePreviousRange = i > 0 && (ele.qty !== rangeQty || hasGapFromPrevious)

                if (shouldClosePreviousRange) {
                    shdlData.push({
                        from: moment.utc(fromDate, 'DD/MM/YYYY', true).toDate(),
                        to: moment.utc(previousDate, 'DD/MM/YYYY', true).toDate(),
                        qty: rangeQty.toFixed(1),
                        work_type: emp.work_type,
                    })
                    fromDate = ele.date;
                    rangeQty = ele.qty;
                }

                if (i === sorted.length - 1) {
                    shdlData.push({
                        from: moment.utc(fromDate, 'DD/MM/YYYY', true).toDate(),
                        to: moment.utc(ele.date, 'DD/MM/YYYY', true).toDate(),
                        qty: rangeQty.toFixed(1),
                        work_type: emp.work_type,
                    })
                }
            })
            obj.shdl_data = shdlData;
            uploadFormattedData.push(obj)
            newarr.push({ ...obj, ...obj.dates })
        });
        this.setState({ reviewTableData: newarr, uploadFormattedData })

    }

    bulkUpload = () => {
        if (this.state.reviewTableData.length === 0) {
            // this.filterExcelDataEmployee();
            return;
        }
        this.setState({ bulkUploadLoader: true, bulkUploadDisabled: true })
        Service.post(conditionalPRPTandPRPRcreate, {
            headers: {
                Authorization: "Token " + token,
            },
            data: this.state.uploadFormattedData
        })
            .then(res => {
                this.getPRPtemplate()
                this.setState({ bulkUploadLoader: false, reviewModal: false, dropZoneModal: false, bulkUploadDisabled: false })
                this.props.enqueueSnackbar('Data uploaded successfully', {
                    variant: 'success'
                });
            })
            .catch(error => {
                if (error && error.status === 400) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    console.log(error)
                    this.setState({ bulkUploadLoader: false, bulkUploadDisabled: false })
                    this.props.enqueueSnackbar('Something went wrong.', {
                        variant: 'error'
                    });
                }
            })
    }

    async filterExcelDataEmployee() {
        this.setState({ bulkUploadLoader: true, bulkUploadDisabled: true })
        let roles = [...this.state.data];
        let empExcelData = [...this.state.reviewTableData];
        let dataToUpdate = [];

        /* Iteration of Employee from review tbale data array */
        for (let i = 0; i < empExcelData.length; i++) {
            /*setting CRM id for employee as project id is CRM id for employee in PRP */
            empExcelData[i]['crm'] = this.props.project.id

            let foundInRoles = false;
            let id;
            //  Checking from roles(or PRP table data existed)
            roles.forEach(role => {
                if (role.role === empExcelData[i].role) {
                    // setting employee PRP id as role id is PRP id for employee in PRP table
                    empExcelData[i]['prp'] = role.id;
                }


                let emp = role['emp'];
                for (let k = 0; k < emp.length; k++) {
                    if (empExcelData[i]['emp_id'] && emp[k]['emp_id'] && (empExcelData[i]['emp_id'] === emp[k]['emp_id'])) {
                        foundInRoles = true;
                        id = emp[k]['id']
                        // break;
                    }
                }

            })

            if (foundInRoles) {
                empExcelData[i]['id'] = id
                dataToUpdate.push(empExcelData[i])
            }
        }

        let dataToUpload = []

        for (let i = 0; i < empExcelData.length; i++) {
            let foundInUpdate = false
            for (let j = 0; j < dataToUpdate.length; j++) {
                if (empExcelData[i].role && dataToUpdate[j].role && empExcelData[i].role === dataToUpdate[j].role) {
                    foundInUpdate = true;
                    break;
                }
            }
            if (!foundInUpdate) dataToUpload.push(empExcelData[i])
        }

        if (dataToUpload.length === 0) {
            this.props.enqueueSnackbar('No new data found!', {
                variant: 'error'
            });
            return;
        }
        /* +++++++++++ Start Upload in DB  ++++++++++++++*/
        if (dataToUpload.length > 0) {
            let added = await this.bulkEmployeeAdd(dataToUpload)
            if (added.success && dataToUpdate.length > 0) {
                await this.bulkEmployeeUpdate(dataToUpdate)
            }

            this.setState({ bulkUploadLoader: false, reviewModal: false, dropZoneModal: false, bulkUploadDisabled: false });
            getActiveRoles();
        }
        else {
            if (dataToUpdate.length > 0) {
                await this.bulkEmployeeUpdate(dataToUpdate)
                this.setState({ bulkUploadLoader: false, reviewModal: false, dropZoneModal: false, bulkUploadDisabled: false });
                getActiveRoles()
            }
        }
        /* ============================== */

    }

    bulkEmployeeAdd(empData) {
        return new Promise((resolve, reject) => {
            Service.post(conditionalPRPTandPRPRcreate, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: empData
            })
                .then(res => {

                    this.props.enqueueSnackbar(res.data.length + (res.data.length === 1 ? ' Employee' : ' Employees') + ' successfully added', {
                        variant: 'success'
                    });

                    resolve({ success: true })
                })
                .catch(error => {
                    console.error(error)
                    if (!error || error.status !== 400) {
                        this.props.enqueueSnackbar('Something went wrong!', {
                            variant: 'error'
                        });
                    }
                    if (error.status === 400) {
                        if (error.data.length) {
                            for (let i = 0; i < error.data.length; i++) {
                                const err = error.data[i]
                                let hasError = Object.keys(err).length !== 0 && err.constructor === Object;
                                if (hasError) {
                                    for (const e in err) {
                                        this.props.enqueueSnackbar("Upload error : " + (empData[i]['emp_id'] ? +'emp_id - ' + empData[i]['emp_id'] : '') + " - " + e + " (" + err[e] + ")", {
                                            variant: 'error'
                                        });
                                        return;
                                    }
                                }
                            }

                        }
                    }
                    reject({ error: false })
                })
        })
    }

    bulkEmployeeUpdate(data) {
        const updatedRows = data.map((row) => {
            const next = { ...row }
            delete next.created_by
            delete next.updated_by
            return next
        })
        return new Promise((resolve, reject) => {
            Service.patch(prp_roles_api_bulk_update, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: updatedRows
            })
                .then(res => {

                    this.props.enqueueSnackbar(res.data.length + (res.data.length === 1 ? ' Employee' : ' Employees') + ' successfully updated', {
                        variant: 'success'
                    });

                    resolve({ success: true })
                })
                .catch(e => {
                    console.error(e)
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                    reject({ success: false })
                })
        })
    }

    dropzoneClose = () => {
        this.setState({
            dropZoneModal: false,
            reviewTableData: [],
            uploadFormattedData: [],
            missingValues: {},
            buttonDisabled: true
        })
    }

    handleTotalType = (e) => {
        let { name, checked } = e.target
        this.setState({ [name]: checked })
        let data = [...this.state.data]
        if (checked === true) {
            for (let i = 0; i < data.length; i++) {
                if (data[i]['total']) {
                    data[i]['total'] = (Number(data[i].total) * 8).toFixed(2)
                }
            }
            this.setState({ data: data })
        }
        if (checked === false) {
            for (let i = 0; i < data.length; i++) {
                if (data[i]['total']) {
                    data[i]['total'] = (Number(data[i].total) / 8).toFixed(2)
                }
            }
            this.setState({ data: data })
        }
    }

    editDesciplineFunc(role, value) {
        role.editDescipline = value
        this.setState({
            data: [...this.state.data],
            selectedDiscipline: this.state.disciplineDropdown.find((item) => item.id === Number(role.descipline))
        })
    }

    submitDescipline(role) {
        if (!this.state.selectedDiscipline) {
            this.props.enqueueSnackbar("Please select a discipline", {
                variant: "warning",
            });
            return;
        } else {
            this.setState({
                coffeeLoading: true
            })
            Service.patch('/api/prp/template/update_discipline/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    id: role.id,
                    crm_id: this.props.project.id,
                    role_id: role.role_id,
                    descipline: this.state.selectedDiscipline.id
                },
            })
                .then((res) => {
                    this.props.enqueueSnackbar("Updated Discpline successfully", {
                        variant: "success",
                    });
                    role.descipline = this.state.selectedDiscipline.id
                    role.editDescipline = false
                    this.setState({ data: [...this.state.data], coffeeLoading: false }, () => {
                        this.handleReload()
                    });

                })
                .catch((error) => {
                    console.log(error)
                    role.editDescipline = false
                    this.setState({ data: [...this.state.data], coffeeLoading: false });
                    this.props.enqueueSnackbar("Something went wrong!", {
                        variant: "error",
                    });
                })
                .finally((e) => {
                });
        }
    }

    handleDiscplineChange = (e, role, columnLabel) => {
        role['editDiscplineField'] = e.target.value
        this.setState({ data: [...this.state.data] })
    }

    tableCellRender(role, columnLabel) {
        // returns a lookup names
        if (columnLabel.field === "role") {
            return columnLabel.lookup[role[columnLabel.field]];
        } else if (columnLabel.field === "updated_info") {
            const updatedInfo = role[columnLabel.field]
            const firstNameOnly = typeof updatedInfo === 'string'
                ? updatedInfo.replace(/^(\s*Name:\s*)(\S+).*$/im, '$1$2')
                : updatedInfo
            return <div style={{ whiteSpace: 'pre-line' }}>{firstNameOnly}</div>
        } else if (columnLabel.field === "descipline") {
            return <Box width={'100px'} display={'flex'} justifyContent={'flex-start'} alignItems='center'>
                {!role.editDescipline ? <div>{columnLabel.lookup[role[columnLabel.field]]}</div> :
                    <Box display={'flex'} justifyContent={'flex-start'} alignItems='center'>
                        <Autocomplete
                            options={this.state.disciplineDropdown}
                            getOptionLabel={(option) => option.name}
                            value={this.state.selectedDiscipline}
                            style={{ width: '100px' }}
                            onChange={(e, value) => {
                                this.setState({
                                    selectedDiscipline: value
                                })
                            }
                            }
                            renderInput={(params) => <TextField {...params} size='small' label="Discpline" variant="outlined" />} />
                    </Box>}
            </Box>;
        } else if (columnLabel.editable === "never") {
            return role.dates[columnLabel.field];
        }
        return role[columnLabel.field];
    }

    handleSelectionChange(row, index) {
        const isNowChecked = !row.isChecked
        const updateRows = (rows) => rows.map((item) => {
            if (item.id !== row.id) return item
            const updatedPrpRole = Array.isArray(item.prp_role)
                ? item.prp_role.map((roleItem) => ({
                    ...roleItem,
                    is_checked: isNowChecked && !roleItem.emp_is_archived
                }))
                : item.prp_role
            return {
                ...item,
                isChecked: isNowChecked,
                prp_role: updatedPrpRole
            }
        })

        const data = updateRows([...this.state.data])
        const copyData = updateRows([...this.state.copyData])

        const deleteRowData = copyData.filter((item) => item.isChecked)
        const deleteRowIndex = deleteRowData.map((item) => item.id)
        const filteredData = this.getRoleGroupFilteredRows(data)
        const allCheck = filteredData.length > 0 && filteredData.every((item) => item.isChecked)

        const selectedEmployees = []
        copyData.forEach((item) => {
            if (item.isChecked && Array.isArray(item.prp_role)) {
                item.prp_role.forEach((roleItem) => {
                    if (roleItem.is_checked && !roleItem.emp_is_archived) {
                        selectedEmployees.push(roleItem)
                    }
                })
            }
        })

        this.setState({
            data,
            copyData,
            deleteRowIndex,
            deleteRowData,
            allCheck,
            selectedEmployees,
            deleteDisabled: deleteRowData.length === 0,
            assignDisabled: this.isAssignDisabledForSelection(selectedEmployees)
        })
    }

    onOpen = () => {
        this.setState({
            showDialog: true,
            multipleSelect: true
        }, () => {
            if (this.empTableRef && this.empTableRef.current) {
                this.empTableRef.current.dialogFunc()
            }
        })

    }

    handleCustomQty = (e, idx, role_id) => {
        let preObj = [...this.state.customQtyValues]
        for (let i = 0; i < preObj.length; i++) {
            if (preObj[i]['role_id'] === role_id) {
                preObj[i]['shdl_data'][idx]['qty'] = e.target.value;
            }
        }
        this.setState({ customQtyValues: preObj })
    }

    handleCustomToDate = (date, index, i) => {
        if (moment(date).format('dddd') === 'Monday') {
            const customQtyValues = this.state.customQtyValues.map((roleData, roleIndex) => {
                if (roleIndex !== index) {
                    return roleData
                }
                return {
                    ...roleData,
                    shdl_data: roleData.shdl_data.map((schedule, scheduleIndex) => {
                        if (scheduleIndex !== i) {
                            return schedule
                        }
                        return {
                            ...schedule,
                            to: moment(date).toISOString()
                        }
                    })
                }
            })
            this.setState({ customQtyValues })
        } else {
            this.props.enqueueSnackbar('Please select Monday as To date', {
                variant: 'warning'
            });
        }
    }

    handleCustomFromDate = (date, index, i) => {
        if (moment(date).format('dddd') === 'Monday') {
            const customQtyValues = this.state.customQtyValues.map((roleData, roleIndex) => {
                if (roleIndex !== index) {
                    return roleData
                }
                return {
                    ...roleData,
                    shdl_data: roleData.shdl_data.map((schedule, scheduleIndex) => {
                        if (scheduleIndex !== i) {
                            return schedule
                        }
                        return {
                            ...schedule,
                            from: moment(date).toISOString()
                        }
                    })
                }
            })
            this.setState({ customQtyValues })
        } else {
            this.props.enqueueSnackbar('Please select Monday as From date', {
                variant: 'warning'
            });
        }
    }

    handleSingleCustomToDate = (date, idx) => {
        if (moment(date).format('dddd') === 'Monday') {
            let preObj = [...this.state.singleCustomQtyValues]
            preObj[idx]['to_date'] = moment(date).toISOString();;
            this.setState({ singleCustomQtyValues: preObj })
        } else {
            this.props.enqueueSnackbar('Please select Monday as To date', {
                variant: 'warning'
            });
        }
    }

    handleSingleCustomFromDate = (date, idx) => {
        if (moment(date).format('dddd') === 'Monday') {
            let preObj = [...this.state.singleCustomQtyValues]
            preObj[idx]['from_date'] = moment(date).toISOString();
            // preObj[idx]['from'] = moment(date).format('DD-MM-YYYY');
            this.setState({ singleCustomQtyValues: preObj })
        } else {
            this.props.enqueueSnackbar('Please select Monday as From date', {
                variant: 'warning'
            });
        }
    }

    handleWorkType = (e, idx) => {
        let preObj = [...this.state.singleCustomQtyValues]
        preObj[idx]['work_type'] = e.target.value;
        this.setState({ singleCustomQtyValues: preObj })
    }

    handleSingleCustomQty = (e, idx) => {
        let preObj = [...this.state.singleCustomQtyValues]
        preObj[idx]['qty'] = e.target.value;
        this.setState({ singleCustomQtyValues: preObj })
    }

    handleType = (e, idx, role_id) => {
        let preObj = [...this.state.customQtyValues]
        for (let i = 0; i < preObj.length; i++) {
            if (preObj[i]['role_id'] === role_id) {
                preObj[i]['type'] = e.target.value
            }
        }
        this.setState({ customQtyValues: preObj })
    }

    addCustomField = (role_id) => {
        let obj = {
            from: this.state.selectedEmployee.contract_end_date,
            to: this.state.selectedEmployee.contract_end_date,
            qty: 0,
            error: false,
            errorMsg: ''
        }
        let preObj = [...this.state.customQtyValues]
        for (let i = 0; i < preObj.length; i++) {
            if (preObj[i]['role_id'] === role_id) {
                preObj[i]['shdl_data'].push(obj)
            }
        }
        this.setState({ customQtyValues: preObj })
    }

    addSingleCustomField = (role_id) => {
        let obj = {
            from: this.state.selectedEmployee.contract_end_date,
            to: this.state.selectedEmployee.contract_end_date,
            qty: 0,
            error: false,
            errorMsg: ''
        }
        let preObj = [...this.state.customQtyValues]
        for (let i = 0; i < preObj.length; i++) {
            if (preObj[i]['role_id'] === role_id) {
                preObj[i]['shdl_data'].push(obj)
            }
        }
        this.setState({ customQtyValues: preObj })
    }

    removeCustomQty = (e, index, i) => {
        const customQtyValues = this.state.customQtyValues.map((roleData, roleIndex) => {
            if (roleIndex !== index) {
                return roleData
            }
            return {
                ...roleData,
                shdl_data: roleData.shdl_data.filter((_, scheduleIndex) => scheduleIndex !== i)
            }
        })
        this.setState({ customQtyValues })
    }

    removeSingleCustomQty = (idx) => {
        let data = [...this.state.singleCustomQtyValues];
        let deleteQtyID = this.state.deleteQtyID
        let deleted_shdl_data = data.splice(idx, 1);
        for (let index = 0; index < deleted_shdl_data.length; index++) {
            const element = deleted_shdl_data[index];
            if (!(element.from === 'undefined' || element.to === 'undefined' || element.qty === 'undefined' || element.qty === '')) {
                deleteQtyID.push(element.id)
            }
        }
        // deleteQtyID
        if (this.state.deleteQtyID.length > 0) {
            this.setState({ deletedQtyValues: true })
        }

        this.setState({ singleCustomQtyValues: data, deleteQtyID: deleteQtyID })
    }

    addSingleCustomQty = () => {
        if (!this.state.singleCustomQtyValues) {
            this.setState({
                singleCustomQtyValues: [
                    {
                        from: this.state.selectedEmployee.contract_start_date,
                        to: this.state.selectedEmployee.contract_end_date,
                        qty: 0,
                        error: false,
                        errorMsg: ''
                    }
                ]
            })
        } else {
            let data = [...this.state.singleCustomQtyValues];
            data.push(
                {
                    from: this.state.selectedEmployee.contract_start_date,
                    to: this.state.selectedEmployee.contract_end_date,
                    qty: 0,
                    error: false,
                    errorMsg: ''
                })
            this.setState({ singleCustomQtyValues: data })
        }

    }

    handleSingleType = (e) => {
        this.setState({ type: e.target.value })
    }

    getResource = (role) => {
        this.setState({ role: role }, () => {
            this.setState({ allocationDialog: true })
        })
    }

    prpBulkEdit() {
        this.setState({
            addQtyDisbaled: true
        })
        let go = true
        this.state.customQtyValues.forEach((shdlData) => {
            if (shdlData.shdl_data.length > 0) {
                shdlData.shdl_data.forEach((ele, i) => {
                    if (ele.from_date && ele.to_date) {
                        if (moment(ele.to).isBefore(moment(ele.from))) {
                            go = false
                            return;
                        }
                    }
                })
            }
        })

        if (!go) {
            this.setState({ addQtyDisbaled: false })
            this.props.enqueueSnackbar('End date should be greater than start date', {
                variant: 'warning'
            });
            return;
        }

        let data = [...this.state.selectedEmployees]
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            let allDatesQty = {};
            // let keys = Object.keshdl_datasys(element.dates);
            let i = this.state.customQtyValues.find(x => x.role_id === element.role_id)
            element.shdl_data = i.shdl_data
            element.type = i.type
            // eslint-disable-next-line array-callback-return 
            i.shdl_data.map((dates, i) => {
                let alldates = weekStartDates(dates.from, dates.to);

                alldates.forEach((date) => {
                    let qty = Number(dates.qty);
                    if (date in allDatesQty) {
                        qty += Number(allDatesQty[date]);
                    }
                    allDatesQty[date] = qty.toFixed(1)
                });
            });
            element.dates = allDatesQty
        }
        this.setState({ selectedData: data }, () => {
            const updatedRows = data.map((row) => {
                const next = { ...row }
                delete next.created_by
                return next
            })
            Service.patch(prp_roles_api_bulk_update, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: updatedRows
            })
                .then(res => {
                    this.props.enqueueSnackbar('Updated Successfully', {
                        variant: 'success'
                    });
                    this.setState({
                        showDialog: false,
                    }, () => {
                        this.setState({
                            addQtyDisbaled: false,
                            customQtyValues: null,
                            multipleSelect: false
                        })
                    })
                    this.setState({ assignDisabled: true, selectedData: [], selectedEmployees: [] })
                    this.closeShowDialog()
                    this.handleReload()
                })
                .catch(e => {
                    console.error(e)
                    this.setState({
                        addQtyDisbaled: false,
                    })
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                    // reject({ success: false })
                })
        })
    }

    applyCustomQty = () => {
        this.prpBulkEdit()
    }

    applySingleCustomQty = (reload) => {
        this.setState({ addQtyDisbaled: true, })
        // try {
        let allDatesQty = {};
        let continueToApply = true;
        this.state.singleCustomQtyValues.forEach((shdlData) => {
            let alldates = weekStartDates(shdlData.from_date, shdlData.to_date);
            alldates.forEach((date) => {
                let qty = Number(shdlData.qty);
                if (date in allDatesQty) {
                    qty += Number(allDatesQty[date]);
                }
                allDatesQty[date] = Number(qty.toFixed(1))
            });
        });

        this.setState({ customQtyValues: this.state.customQtyValues });

        if (!continueToApply) {
            this.setState({ addQtyDisbaled: false })
            return;
        }

        if (this.state.deleteQtyID.length > 0) {
            Service.delete(`/api/role/schedule/delete_shdl_data/?id=` + this.state.deleteQtyID.join(','), {
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then((res) => {
                    this.setState({ deleteQtyID: [] })
                })
                .catch((error) => {
                    console.log(error)
                    this.props.enqueueSnackbar("Something went wrong!", {
                        variant: "error",
                    });
                })
                .finally((e) => {
                });
        }

        let updatedData = []
        let go = true
        for (let i = 0; i < this.state.singleCustomQtyValues.length; i++) {
            const element = this.state.singleCustomQtyValues[i];
            if (element.from_date && element.to_date) {
                if (moment(element.to_date).isBefore(moment(element.from_date))) {
                    go = false
                    break
                } else {
                    element.from = moment(element.from_date).format("YYYY-MM-DD")
                    element.to = moment(element.to_date).format("YYYY-MM-DD")
                    delete element.from_date
                    delete element.to_date
                    updatedData.push(element)
                }
            }
        }
        if (go) {
            Service.put(prp_roles_api + this.state.selectedEmployee.id + "/", {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    shdl_data: updatedData,
                    employee: this.state.selectedEmployee.employee,
                    dates: allDatesQty,
                    type: this.state.type,
                },
            })
                .then((res) => {
                    this.props.enqueueSnackbar("Updated successfully", {
                        variant: "success",
                    });
                    this.setState({ addQtyDisbaled: false, });
                    if (reload) {
                        this.handleReload();
                    }

                })
                .catch((error) => {
                    console.log(error)
                    this.setState({ addQtyDisbaled: false, singleShowDialog: false })
                    this.props.enqueueSnackbar("Something went wrong!", {
                        variant: "error",
                    });
                })
                .finally((e) => {
                });
        } else {
            this.props.enqueueSnackbar("End date should be greater than start date", {
                variant: "warning",
            });
            this.setState({ addQtyDisbaled: false })
        }

        // } catch (e) {
        //     this.setState({ addQtyDisbaled: false })
        // }
        // }
    };

    handleSearchChange(data) {
        const data_lowercase = data.toLowerCase()
        var search_words = data_lowercase.split(" ");
        search_words = search_words.filter(n => n)
        var filtered_data = []
        if (search_words.length === 0) {
            filtered_data = this.state.copyData
        }

        for (let i = 0; i < this.state.copyData.length; i++) {
            const element = this.state.copyData[i];
            var num_of_passed = false
            for (let j = 0; j < search_words.length; j++) {
                const el = search_words[j];
                // const role = this.state.rolesObj[element.role]
                if (element.role_name) {
                    const role = element.role_name
                    if (role !== undefined)
                        num_of_passed = role.toLowerCase().includes(el)
                    if (!num_of_passed) {
                        break
                    }
                }

            }
            if (num_of_passed) {
                filtered_data.push(element)
            }
        }
        if (data.length === 0) {
            localStorage.removeItem("searchKey")
            localStorage.removeItem("openedRows")
            this.setState({ openedRows: [], openedRowIds: {} })
        } else {
            localStorage.setItem("searchKey", data)
        }
        const filteredRows = this.getRoleGroupFilteredRows(filtered_data, this.state.selectedRoleGroup)
        const allCheck = filteredRows.length > 0 && filteredRows.every((item) => item.isChecked)
        const deleteRowData = this.state.copyData.filter((item) => item.isChecked)
        const deleteRowIndex = deleteRowData.map((item) => item.id)
        this.setState({ data: filtered_data, allCheck, deleteRowData, deleteRowIndex, deleteDisabled: deleteRowData.length === 0 })
    }

    getSingleRoleData = (role) => {
        const updateRows = (rows = []) => {
            const index = rows.findIndex((item) => item.id === role.id)
            if (index < 0) {
                return rows
            }

            const previous = rows[index]
            let updatedRole = {
                ...role,
                isChecked: Boolean(previous?.isChecked),
                editDescipline: Boolean(previous?.editDescipline)
            }
            updatedRole = this.normalizeRoleUpdatedInfo(updatedRole, previous)

            if (Array.isArray(updatedRole.prp_role)) {
                updatedRole.prp_role = updatedRole.prp_role.map((roleItem) => ({
                    ...roleItem,
                    descipline: updatedRole.descipline
                }))
            }

            const nextRows = [...rows]
            nextRows.splice(index, 1, updatedRole)
            return nextRows
        }

        this.setState((prevState) => {
            const data = updateRows(prevState.data)
            const copyData = updateRows(prevState.copyData)
            const filteredRows = this.getRoleGroupFilteredRows(data, prevState.selectedRoleGroup)
            const allCheck = filteredRows.length > 0 && filteredRows.every((item) => item.isChecked)
            const deleteRowData = copyData.filter((item) => item.isChecked)
            const deleteRowIndex = deleteRowData.map((item) => item.id)

            return {
                data,
                copyData,
                allCheck,
                deleteRowData,
                deleteRowIndex,
                deleteDisabled: deleteRowData.length === 0
            }
        })
    }

    scrolltoTop() {
        if (this.topRef.current) {
            this.topRef.current.scrollIntoView({ behavior: "smooth" })
        }
    }

    openBulkUpload = () => {
        this.setState({ dropZoneModal: true })
    }

    handleRoleGroupChange = (value) => {
        if (!value) {
            localStorage.removeItem("selectedRoleGroup")
            const filteredRows = this.getRoleGroupFilteredRows(this.state.data, null)
            const deleteRowData = this.state.copyData.filter((item) => item.isChecked)
            const deleteRowIndex = deleteRowData.map((item) => item.id)
            const allCheck = filteredRows.length > 0 && filteredRows.every((item) => item.isChecked)
            this.setState({
                selectedRoleGroup: null,
                allCheck,
                deleteRowData,
                deleteRowIndex,
                deleteDisabled: deleteRowData.length === 0
            })
            return
        } else {
            localStorage.setItem("selectedRoleGroup", JSON.stringify(value))
        }
        const filteredRows = this.getRoleGroupFilteredRows(this.state.data, value)
        const deleteRowData = this.state.copyData.filter((item) => item.isChecked)
        const deleteRowIndex = deleteRowData.map((item) => item.id)
        const allCheck = filteredRows.length > 0 && filteredRows.every((item) => item.isChecked)
        this.setState({
            selectedRoleGroup: value,
            allCheck,
            deleteRowData,
            deleteRowIndex,
            deleteDisabled: deleteRowData.length === 0
        })
    }

    getRoleGroupFilteredRows = (data = this.state.data, rolesSearch = this.state.selectedRoleGroup) => {
        return data.filter((item) => this.customRoleFilterAndSearch(item, rolesSearch))
    }

    customRoleFilterAndSearch = (data, rolesSearch) => {
        if (rolesSearch && rolesSearch.role_ids) {
            if (rolesSearch.role_ids.includes(data.role_id)) {
                return true
            } else {
                return false
            }
        } else {
            return true
        }
    }


    switchTabs = (e) => {
        this.setState({
            tabChangeAlert: false,
        }, () => {
            this.handleTabChange(e, this.state.selectedTabValue)
        })

    }

    deleteOrUnallocateSchedules(method, ele, i) {
        this.setState({ coffeeLoading: true })
        Service.delete(`/api/role/schedule/delete_shdl_data/?id=` + ele.id + '&method=' + method, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then((res) => {
                this.props.enqueueSnackbar('Schedule ' + method + "d successfully", {
                    variant: "success",
                });
                this.removeSingleCustomQty(i)
                this.setState({ coffeeLoading: false, selectedElement: null, selectedIndex: null, unallocateDeleteDialog: false })
            })
            .catch((error) => {
                console.log(error)
                this.setState({ coffeeLoading: false })
                this.props.enqueueSnackbar("Something went wrong!", {
                    variant: "error",
                });
            })
    }

    deleteCheck(element, index) {
        if (element.reporting_available) {
            this.setState({ selectedElement: element, selectedIndex: index, unallocateDeleteDialog: true })
        } else {
            this.deleteOrUnallocateSchedules('delete', element, index)
        }
    }

    increaseDialogSize = () => {
        this.setState({ allocationDialogSize: 'xl' })
    }

    decreaseDialogSize = () => {
        this.setState({ allocationDialogSize: 'md' })
    }



    handleTabChange = (event, newValue) => {
        if (this.state.tabChangeAlert) {
            this.setState({ openConfirmationDialog: true, selectedTabValue: newValue })
        } else {
            this.setState({ allocationDialogSize: 'md', tabValue: newValue, tabChangeAlert: false, openConfirmationDialog: false })
        }
    }


    tabChangeAlert = (value) => {
        this.setState({ tabChangeAlert: value })
    }
    removeEmployeewithoutReload = (id, roleData) => {
        let data = [...this.state.data]
        let findIndex = data.findIndex(x => x.id === roleData.id)
        if (findIndex >= 0) {
            data[findIndex].prp_role.map((item, index) => {
                if (item.id === id) {
                    item.emp_first_name = null
                    item.emp_last_name = null
                    item.subcontractor_company_name = null
                    item.atr_bbuk_number = null
                }
                return item
            })
        }
        this.setState({ data })

        let copyData = [...this.state.copyData]
        let findIndex1 = copyData.findIndex(x => x.id === roleData.id)
        if (findIndex1 >= 0) {
            copyData[findIndex1].prp_role.map((item, index) => {
                if (item.id === id) {
                    item.emp_first_name = null
                    item.emp_last_name = null
                    item.subcontractor_company_name = null
                    item.atr_bbuk_number = null
                }
                return item
            })
        }
        this.setState({ copyData })
    }


    handleAllCheck = (checked) => {
        let data = [...this.state.data]
        let copyData = [...this.state.copyData]

        const filteredIds = new Set(this.getRoleGroupFilteredRows(data).map((item) => item.id))

        const syncRowSelection = (rows, rowChecked) => {
            return rows.map((item) => {
                const shouldUpdate = filteredIds.has(item.id)
                if (!shouldUpdate && checked) {
                    return item
                }
                const prpRole = Array.isArray(item.prp_role)
                    ? item.prp_role.map((roleItem) => ({ ...roleItem, is_checked: rowChecked }))
                    : item.prp_role
                return {
                    ...item,
                    isChecked: shouldUpdate ? rowChecked : false,
                    prp_role: prpRole
                }
            })
        }

        if (!checked) {
            data = syncRowSelection(data, false)
            copyData = syncRowSelection(copyData, false)
            this.setState({
                data,
                copyData,
                allCheck: false,
                deleteDisabled: true,
                deleteRowData: [],
                deleteRowIndex: [],
                selectedEmployees: [],
                assignDisabled: true
            })
            return
        }

        data = syncRowSelection(data, true)
        copyData = syncRowSelection(copyData, true)

        const selectedEmployees = []
        copyData.forEach((item) => {
            if (item.isChecked && Array.isArray(item.prp_role)) {
                item.prp_role.forEach((roleItem) => {
                    if (!roleItem.emp_is_archived) {
                        selectedEmployees.push({ ...roleItem, is_checked: true })
                    }
                })
            }
        })

        const deleteRowData = data.filter((item) => item.isChecked)
        const deleteRowIndex = deleteRowData.map((item) => item.id)
        const filteredData = this.getRoleGroupFilteredRows(data)
        const allCheck = filteredData.length > 0 && filteredData.every((item) => item.isChecked)
        this.setState({
            data,
            copyData,
            allCheck,
            deleteDisabled: deleteRowData.length === 0,
            deleteRowData,
            deleteRowIndex,
            selectedEmployees,
            assignDisabled: this.isAssignDisabledForSelection(selectedEmployees)
        })
    }

    submitRoleId() {
        if (this.state.bulkDates.start_date === null || this.state.bulkDates.end_date === null) {
            this.props.enqueueSnackbar("Please select both start and end dates!", {
                variant: "warning",
            });
            return;
        } else if (this.state.bulkDates.start_date > this.state.bulkDates.end_date) {
            this.props.enqueueSnackbar("Start date should be less than end date!", {
                variant: "warning",
            });
            return;
        } else {
            // `/api/role/schedule/get_template_role_schedule/?role_schedule_ids=${this.state.selectedEmployees.map(emp => emp.id).join(',')}&from_date=${moment(this.state.bulkDates.start_date).format('DD-MM-YYYY')}&to_date=${moment(this.state.bulkDates.end_date).format('DD-MM-YYYY')}`
            Service.get(`/api/role/schedule/get_template_role_schedule/?role_schedule_ids=${this.state.selectedEmployees.map(emp => emp.id).join(',')}&from_date=${moment(this.state.bulkDates.start_date).format('DD-MM-YYYY')}&to_date=${moment(this.state.bulkDates.end_date).format('DD-MM-YYYY')}`, {
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then((res) => {
                    if (this.isUnmounted) {
                        return
                    }
                    this.setState({ roleScheduleData: res.data, bulkDisplaySelectedRowIds: [], bulkDisplayExpandedRowIds: [] }, () => {
                        this.setState({ bulkDisplayDialog: true })
                    })

                })
                .catch((error) => {
                    console.log(error)
                    this.props.enqueueSnackbar("Something went wrong!", {
                        variant: "error",
                    });
                })
        }
    }


    getBulkDisplayRowId = (row, index) => {
        if (row?.id !== undefined && row?.id !== null) return String(row.id)
        if (row?.role_schedule_id !== undefined && row?.role_schedule_id !== null) return String(row.role_schedule_id)
        if (row?.schedule_id !== undefined && row?.schedule_id !== null) return String(row.schedule_id)
        return String(index)
    }

    getBulkDisplayRowsByIds = (selectedIds = this.state.bulkDisplaySelectedRowIds, rows = this.state.roleScheduleData) => {
        if (!Array.isArray(rows) || !Array.isArray(selectedIds) || selectedIds.length === 0) {
            return []
        }
        const selectedIdSet = new Set(selectedIds)
        return rows.filter((row, index) => selectedIdSet.has(this.getBulkDisplayRowId(row, index)))
    }

    handleBulkDisplayRowSelection = (row, index, checked) => {
        const rowId = this.getBulkDisplayRowId(row, index)
        this.setState((prevState) => {
            const selected = [...(prevState.bulkDisplaySelectedRowIds || [])]
            const selectedIndex = selected.indexOf(rowId)

            if (checked && selectedIndex === -1) {
                selected.push(rowId)
            }

            if (!checked && selectedIndex > -1) {
                selected.splice(selectedIndex, 1)
            }
            return {
                bulkDisplaySelectedRowIds: selected
            }
        })
    }

    handleBulkDisplaySelectAll = (rows, checked) => {
        if (!checked) {
            this.setState({ bulkDisplaySelectedRowIds: [] })
            return
        }

        const selectedIds = rows.map((row, index) => this.getBulkDisplayRowId(row, index))
        this.setState({ bulkDisplaySelectedRowIds: selectedIds })
    }

    handleBulkDisplayRowToggle = (row, index) => {
        const rowId = this.getBulkDisplayRowId(row, index)
        const expanded = [...(this.state.bulkDisplayExpandedRowIds || [])]
        const expandedIndex = expanded.indexOf(rowId)

        if (expandedIndex > -1) {
            expanded.splice(expandedIndex, 1)
        } else {
            expanded.push(rowId)
        }

        this.setState({ bulkDisplayExpandedRowIds: expanded })
    }

    submitBulkDisplay = () => {
        const selectedRows = this.getBulkDisplayRowsByIds()
        const selectedCount = selectedRows.length
        if (selectedCount === 0) {
            this.props.enqueueSnackbar('Please select at least one row.', {
                variant: 'warning'
            })
            return
        } else {
            let template_ids = []
            let role_schedule_ids = []
            for (let index = 0; index < selectedRows.length; index++) {
                const element = selectedRows[index];
                template_ids.push(element.template_id)
                const roleSchedules = Array.isArray(element.role_schedules) ? element.role_schedules : []
                for (let index1 = 0; index1 < roleSchedules.length; index1++) {
                    role_schedule_ids.push(roleSchedules[index1].id)
                }
            }
            Service.patch(`/api/role/schedule/bulk_update_role_schedule/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    'template_ids': template_ids,
                    'role_schedule_ids': role_schedule_ids,
                    'new_from_date': selectedRows[0].new_from_date,
                    'new_to_date': selectedRows[0].new_to_date
                }

            })
                .then((res) => {
                    this.props.enqueueSnackbar('Updated successfully', {
                        variant: 'success'
                    })
                    this.setState({
                        bulkDisplaySelectedRowIds: [],
                        bulkDisplayExpandedRowIds: [],
                        allCheck: false,
                        deleteDisabled: true,
                        deleteRowData: [],
                        deleteRowIndex: [],
                        selectedEmployees: [],
                        assignDisabled: true

                    })
                    this.handleReload()

                })
                .catch((error) => {
                    console.log(error)
                    this.props.enqueueSnackbar("Something went wrong!", {
                        variant: "error",
                    });
                })
        }

        this.setState({ bulkDisplayDialog: false, dateDialog: false })
    }


    tabChangeAlert = (value) => {
        this.setState({ tabChangeAlert: value })
    }

    submitProjectType = () => {
        if (this.state.isSubmittingResourceProfile) return

        if (this.state.selectedImportProfileRow.length === 0) {
            this.props.enqueueSnackbar('Please select at least one resource profile row.', {
                variant: 'warning'
            })
            return;
        } else {
            let stage_allocations = []
            for (let i = 0; i < this.state.selectedImportProfileRow.length; i++) {
                stage_allocations.push({
                    type: this.state.selectedImportProfileRow[i]?.stageData?.key,
                    project_type_ids: [this.state.selectedImportProfileRow[i].id]
                })
            }
            this.setState({ isSubmittingResourceProfile: true })
            Service.post('/api/crm/automate_resource_profile_allocation/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    crm_id: this.state.projectDetails.crm_id,
                    stage_allocations: stage_allocations
                },
            })
                .then(res => {
                    this.props.enqueueSnackbar('Resource profile data loaded successfully.', {
                        variant: 'success'
                    })
                    this.setState({
                        resourceProfileOpen: false,
                        importProfileOpen: false,
                        importProfileStep: 0,
                        isSubmittingResourceProfile: false,
                    })
                })
                .catch(error => {
                    console.log(error)
                    this.setState({ isSubmittingResourceProfile: false })
                    this.props.enqueueSnackbar('Unable to load resource profile data.', {
                        variant: 'error'
                    })
                })
        }

    }




    render() {

        const { classes } = this.props;

        const handleClose = () => {
            this.setState({ allocationDialog: false, allocationDialogSize: "md", addResource: false, tabValue: 0, tabChangeAlert: false })
        };


        const roleGroupFilteredData = this.getRoleGroupFilteredRows()
        const selectedRolesCount = (this.state.copyData || []).filter((item) => item.isChecked).length
        const nestedSelectedCount = (this.state.selectedEmployees || []).length
        const hasBulkScheduleData = Array.isArray(this.state.customQtyValues)
            && this.state.customQtyValues.some((roleData) => Array.isArray(roleData.shdl_data) && roleData.shdl_data.length > 0)
        const bulkDisplayRows = Array.isArray(this.state.roleScheduleData) ? this.state.roleScheduleData : []
        const bulkDisplaySelectedRowIds = this.state.bulkDisplaySelectedRowIds || []
        const bulkDisplayAllChecked = bulkDisplayRows.length > 0 && bulkDisplayRows.every((row, index) => {
            const rowId = this.getBulkDisplayRowId(row, index)
            return bulkDisplaySelectedRowIds.includes(rowId)
        })
        const hasImportProfileDetailsChanges = getImportProfileDetailsSignature(this.state.importProfileSelections)
            !== getImportProfileDetailsSignature(this.state.importProfileInitialSelections)
        const hasImportProfileStageDisciplineChanges = getImportProfileStageDisciplineSignature(this.state.importProfileSelections)
            !== getImportProfileStageDisciplineSignature(this.state.importProfileInitialSelections)
        const hasRequiredImportProfileStageDisciplineSelections = importProfileSections.every(section => {
            const selection = this.state.importProfileSelections[section.key]
            return selection?.stage !== ''
                && selection?.stage !== null
                && selection?.stage !== undefined
                && Array.isArray(selection?.disciplineIds)
                && selection.disciplineIds.length > 0
        })
        const contractAwardValue = this.state.importProfileSelections.contractAwardValue
        const hasRequiredImportProfileDetails = String(contractAwardValue ?? '').trim() !== ''
            && Number.isFinite(Number(contractAwardValue))
            && Number(contractAwardValue) >= 0
            && importProfileSections.every(section => {
                const selection = this.state.importProfileSelections[section.key]
                return selection?.startDate
                    && moment(selection.startDate).isValid()
                    && selection?.endDate
                    && moment(selection.endDate).isValid()
            })
                const isProfileDetailsSaveNextDisabled = this.state.isSavingImportProfile
                    || !hasImportProfileDetailsChanges
                    || !hasRequiredImportProfileDetails


        return (
            <div>
                {this.state.isLoading ? <RotateCircleLoading color={getPrimaryColor()} /> :
                    <div>
                        <Paper elevation={2} style={{ padding: "4px", marginBottom: "5px", backgroundColor: '#AFD6CB' }}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>Project Name :</b> &nbsp;
                                    {this.state.projectDetails.crm_name}
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>Project Number :</b>&nbsp;
                                    {this.state.projectDetails.opportunity_id}
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>Contract Award Date :</b>&nbsp;
                                    {this.state.projectDetails.contractor_start_date ? moment(this.state.projectDetails.contractor_start_date).startOf('day').format('DD/MM/YYYY') : ' - '}
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>Contract End Date :</b>&nbsp;
                                    {this.state.projectDetails.contractor_end_date ? moment(this.state.projectDetails.contractor_end_date).startOf('day').format('DD/MM/YYYY') : ' - '}
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>ECI Start Date:</b> &nbsp;
                                    {this.state.projectDetails.eci_start_date ? moment(this.state.projectDetails.eci_start_date).startOf('day').format('DD/MM/YYYY') : ' - '}
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>ECI End Date:</b>&nbsp;
                                    {this.state.projectDetails.eci_end_date ? moment(this.state.projectDetails.eci_end_date).startOf('day').format('DD/MM/YYYY') : ' - '}
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>Stage1 Start Date:</b>&nbsp;
                                    {this.state.projectDetails.stage1_start_date ? moment(this.state.projectDetails.stage1_start_date).startOf('day').format('DD/MM/YYYY') : ' - '}
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>Stage1 End Date :</b>&nbsp;
                                    {this.state.projectDetails.stage1_end_date ? moment(this.state.projectDetails.stage1_end_date).startOf('day').format('DD/MM/YYYY') : ' - '}
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>Stage2 Start Date:</b> &nbsp;
                                    {this.state.projectDetails.stage2_start_date ? moment(this.state.projectDetails.stage2_start_date).startOf('day').format('DD/MM/YYYY') : ' - '}
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>Stage2 End Date:</b>&nbsp;
                                    {this.state.projectDetails.stage2_end_date ? moment(this.state.projectDetails.stage2_end_date).startOf('day').format('DD/MM/YYYY') : ' - '}
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                    <b>Contract Award Value:</b>&nbsp;
                                    {this.state.projectDetails.contract_award_value ? new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(this.state.projectDetails.contract_award_value) : ' - '}
                                </Grid>
                            </Grid>
                        </Paper>

                        <Paper elevation={2} style={{ padding: "4px", marginBottom: "5px", }}>
                            <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'} >
                                {this.props.addPRPAccess ?
                                    <Button disabled={this.state.addRoleDisabled} size="small" color='primary' variant="contained" onClick={this.addRole} startIcon={<PersonAddIcon />}>
                                        Add Role
                                    </Button>
                                    : null}

                                <Button
                                    startIcon={<WorkIcon />}
                                    disabled={this.state.assignDisabled}
                                    size="small" variant="contained" color='primary' onClick={this.onOpen}>
                                    Assign Selected
                                </Button>

                                <Button
                                    color='primary'
                                    style={!this.state.deleteDisabled ? { backgroundColor: '#d32f2f', color: '#fff' } : undefined}
                                    size="small"
                                    variant="contained"
                                    disabled={this.state.deleteDisabled}
                                    startIcon={<DeleteIcon />}
                                    onClick={() => {
                                        this.deleteAlert()
                                    }}>
                                    Delete Role
                                </Button>

                                <Button color='primary' size="small" variant="contained" disabled={this.state.deleteDisabled} startIcon={<CalendarTodayIcon />} onClick={() => {
                                    this.setState({ dateDialog: true })
                                }}>
                                    Set Dates
                                </Button>
                                <Button
                                    color='secondary'
                                    size='small'
                                    variant='contained'
                                    startIcon={<ImportExportIcon />}
                                    onClick={this.openImportProfile}
                                >
                                    Import Profile
                                </Button>

                                <TextField
                                    autoFocus
                                    autoComplete='off'
                                    size='small'
                                    placeholder="Search"
                                    id="search"
                                    variant='outlined'
                                    value={localStorage.getItem("searchKey") ? localStorage.getItem("searchKey") : ''}
                                    onChange={(e) => this.handleSearchChange(e.target.value)}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start"><SearchIcon fontSize='small' /></InputAdornment>,
                                        endAdornment: <InputAdornment position="end">
                                            <IconButton onClick={() => { localStorage.removeItem("searchKey"); this.handleSearchChange('') }}>
                                                <CloseIcon fontSize='small' />
                                            </IconButton>
                                        </InputAdornment>
                                    }} />

                                <Autocomplete
                                    size='small'
                                    id="combo-box-demo"
                                    options={this.state.roleGroups}
                                    disabled={this.state.addRoleDisabled}
                                    getOptionLabel={(option) => option.name}
                                    style={{ width: 300 }}
                                    value={this.state.selectedRoleGroup}
                                    onChange={(e, value) => this.handleRoleGroupChange(value)}
                                    renderInput={(params) => <TextField {...params} label="Role Group" variant="outlined" />} />

                                <ToggleButtonGroup
                                    exclusive
                                    aria-label="text alignment"
                                    style={{ float: 'right', }}
                                    size='small'>
                                    <ToggleButton value="weeks" aria-label="by week" onClick={this.decreaseZoom} >
                                        <ZoomOut />
                                    </ToggleButton>
                                    <ToggleButton value="months" aria-label="by month" onClick={this.increaseZoom}>
                                        <ZoomIn />
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Paper>

                        <Dialog
                            open={this.state.importProfileOpen}
                            onClose={this.closeImportProfile}
                            maxWidth='md'
                            fullWidth
                        >
                            <DialogTitle>
                                <Box display='flex' alignItems='center' justifyContent='space-between'>
                                    <Typography variant='h6'>Import Profile</Typography>
                                    <IconButton aria-label='Close Import Profile' onClick={this.closeImportProfile}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </DialogTitle>
                            <DialogContent dividers>
                                <Stepper activeStep={this.state.importProfileStep} alternativeLabel>
                                    <Step><StepLabel>Profile Details</StepLabel></Step>
                                    <Step><StepLabel>Stage &amp; Discipline</StepLabel></Step>
                                    <Step><StepLabel>Resource Profile</StepLabel></Step>
                                    <Step><StepLabel>Confirmation</StepLabel></Step>
                                </Stepper>

                                {this.state.importProfileStep === 0 ? (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    type='number'
                                                    label='Contract Award Value'
                                                    variant='outlined'
                                                    size='small'
                                                    value={this.state.importProfileSelections.contractAwardValue}
                                                    onChange={event => {
                                                        const contractAwardValue = event.target.value;
                                                        this.setState(previousState => ({
                                                            importProfileSelections: {
                                                                ...previousState.importProfileSelections,
                                                                contractAwardValue,
                                                            },
                                                        }));
                                                    }}
                                                    inputProps={{ min: 0, step: 'any' }}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position='start'>£</InputAdornment>,
                                                    }}
                                                />
                                            </Grid>
                                            {importProfileSections.map(section => {
                                                const sectionSelection = this.state.importProfileSelections[section.key]

                                                return (
                                                    <Grid item xs={12} key={section.key}>
                                                        <Box p={2} border={1} borderColor='grey.300' borderRadius={4}>
                                                            <Typography variant='subtitle1' gutterBottom>
                                                                {section.label}
                                                            </Typography>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={6}>
                                                                    <DatePicker
                                                                        fullWidth
                                                                        inputVariant='outlined'
                                                                        size='small'
                                                                        format='dd/MM/yyyy'
                                                                        label='Start date'
                                                                        value={sectionSelection.startDate}
                                                                        onChange={value => this.updateImportProfileSelection(section.key, 'startDate', value)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} sm={6}>
                                                                    <DatePicker
                                                                        fullWidth
                                                                        inputVariant='outlined'
                                                                        size='small'
                                                                        format='dd/MM/yyyy'
                                                                        label='End date'
                                                                        value={sectionSelection.endDate}
                                                                        onChange={value => this.updateImportProfileSelection(section.key, 'endDate', value)}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Grid>
                                                )
                                            })}
                                        </Grid>
                                    </MuiPickersUtilsProvider>
                                ) : this.state.importProfileStep === 1 ? (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <Grid container spacing={2}>
                                            {importProfileSections.map(section => {
                                                const sectionSelection = this.state.importProfileSelections[section.key]
                                                const disciplineLabelId = `${section.key}-disciplines-label`

                                                return (
                                                    <Grid item xs={12} key={section.key}>
                                                        <Box p={2} border={1} borderColor='grey.300' borderRadius={4}>
                                                            <Typography variant='subtitle1' gutterBottom>
                                                                {section.label}
                                                            </Typography>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={6} md={3}>
                                                                    <DatePicker
                                                                        disabled
                                                                        fullWidth
                                                                        inputVariant='outlined'
                                                                        size='small'
                                                                        format='dd/MM/yyyy'
                                                                        label='Start date'
                                                                        value={sectionSelection.startDate}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={3}>
                                                                    <DatePicker
                                                                        disabled
                                                                        fullWidth
                                                                        inputVariant='outlined'
                                                                        size='small'
                                                                        format='dd/MM/yyyy'
                                                                        label='End date'
                                                                        value={sectionSelection.endDate}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={3}>
                                                                    <TextField
                                                                        select
                                                                        fullWidth
                                                                        size='small'
                                                                        variant='outlined'
                                                                        label='Stage'
                                                                        value={sectionSelection.stage}
                                                                        onChange={event => this.updateImportProfileSelection(section.key, 'stage', event.target.value)}
                                                                    >
                                                                        {this.state.stageGate.map(stage => (
                                                                            <MenuItem key={stage.id} value={stage.id}>{stage.name}</MenuItem>
                                                                        ))}
                                                                    </TextField>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={3}>
                                                                    <FormControl fullWidth variant='outlined' size='small'>
                                                                        <InputLabel id={disciplineLabelId}>Disciplines</InputLabel>
                                                                        <Select
                                                                            labelId={disciplineLabelId}
                                                                            multiple
                                                                            value={sectionSelection.disciplineIds}
                                                                            onChange={event => this.updateImportProfileSelection(section.key, 'disciplineIds', event.target.value)}
                                                                            renderValue={selected => selected.map(disciplineId => (
                                                                                this.state.disciplineDropdown.find(discipline => String(discipline.id) === String(disciplineId))?.name
                                                                            )).filter(Boolean).join(', ')}
                                                                            label='Disciplines'
                                                                        >
                                                                            {this.state.disciplineDropdown.map(discipline => (
                                                                                <MenuItem key={discipline.id} value={discipline.id}>
                                                                                    <Checkbox
                                                                                        size='small'
                                                                                        color='primary'
                                                                                        checked={sectionSelection.disciplineIds.some(disciplineId => String(disciplineId) === String(discipline.id))}
                                                                                    />
                                                                                    <Typography variant='body2'>{discipline.name}</Typography>
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Grid>
                                                )
                                            })}
                                        </Grid>
                                    </MuiPickersUtilsProvider>
                                ) : this.state.importProfileStep === 2 ? (
                                    <Box display='flex' flexDirection='column' alignItems='center' py={6}>
                                        <Button
                                            color='primary'
                                            variant='contained'
                                            onClick={() => this.setState({ resourceProfileOpen: true })}
                                            disabled={this.state.resourceProfileLoading}
                                        >
                                            {this.state.resourceProfileLoading ? 'Loading...' : 'Open Resource Profile'}
                                        </Button>
                                    </Box>
                                ) : (
                                    <Alert severity='warning'>
                                        Once submitted, this resource profile allocation can only be deleted manually. Please review your selected project types and stages before proceeding. Continue only if you are sure.
                                    </Alert>
                                )}
                            </DialogContent>
                            <DialogActions>
                                {this.state.importProfileStep > 0 && (
                                    <Button color='secondary' variant='contained' onClick={() => this.setState(previousState => ({ importProfileStep: previousState.importProfileStep - 1 }))}>Back</Button>
                                )}
                                {this.state.importProfileStep === 0 && (
                                    <Button
                                        color='primary'
                                        variant='contained'
                                        disabled={this.state.isSavingImportProfile || !isProfileDetailsSaveNextDisabled}
                                        onClick={() => this.setState(previousState => ({ importProfileStep: previousState.importProfileStep + 1 }))}
                                    >
                                        Next
                                    </Button>
                                )}
                                {this.state.importProfileStep < 2 && (
                                    <Button
                                        color='primary'
                                        variant='contained'
                                        disabled={this.state.importProfileStep === 0
                                            ? isProfileDetailsSaveNextDisabled
                                            : !hasImportProfileStageDisciplineChanges || !hasRequiredImportProfileStageDisciplineSelections}
                                        onClick={() => this.saveImportProfileAndContinue(this.state.importProfileStep + 1)}
                                    >
                                        {this.state.importProfileStep === 0
                                            ? this.state.isSavingImportProfile ? 'Saving...' : 'Save & Next'
                                            : 'Next'}
                                    </Button>
                                )}
                                    {this.state.importProfileStep === 3 && (
                                        <Button
                                            color='primary'
                                            variant='contained'
                                            disabled={this.state.isSubmittingResourceProfile}
                                            onClick={this.submitProjectType}
                                        >
                                            {this.state.isSubmittingResourceProfile ? 'Proceeding...' : 'Proceed'}
                                        </Button>
                                    )}
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            fullScreen
                            open={this.state.resourceProfileOpen}
                            onClose={() => this.setState({ resourceProfileOpen: false })}
                        >
                            <AppBar position='static'>
                                <Toolbar>
                                    <Typography variant='h6' noWrap style={{ flexGrow: 1 }}>
                                        Resource Profile
                                    </Typography>
                                    <Button
                                        color='inherit'
                                        variant='outlined'
                                        style={{ marginRight: 8 }}
                                        onClick={() => this.setState({ resourceProfileOpen: false, importProfileStep: 3 })}
                                    >
                                        Submit
                                    </Button>
                                    <IconButton
                                        color='inherit'
                                        aria-label='Close resource profile'
                                        edge='end'
                                        onClick={() => this.setState({ resourceProfileOpen: false })}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Toolbar>
                            </AppBar>
                            <DialogContent dividers>
                                <Box width='100%'>
                                    {this.state.resourceProfileLoading ? (
                                        <Box display='flex' justifyContent='center' alignItems='center' minHeight={240}>
                                            <RotateCircleLoading color={getPrimaryColor()} />
                                        </Box>
                                    ) : (
                                        <>
                                            <Tabs
                                                value={this.state.resourceProfileTab}
                                                onChange={(event, value) => this.setState({
                                                    resourceProfileTab: value,
                                                    resourceProfileDisciplineTab: 0,
                                                })}
                                                centered
                                                indicatorColor='primary'
                                                textColor='primary'
                                                aria-label='Resource profile types'
                                            >
                                                {this.state.importProfileData.map((row, index) => (
                                                    <Tab
                                                        key={`${row.type || 'profile'}-${index}`}
                                                        label={row.type || `Profile ${index + 1}`}
                                                        id={`resource-profile-tab-${index}`}
                                                        aria-controls={`resource-profile-panel-${index}`}
                                                    />
                                                ))}
                                            </Tabs>
                                            {(() => {
                                                const selectedProfile = this.state.importProfileData[this.state.resourceProfileTab]
                                                const disciplines = Array.isArray(selectedProfile?.descipline)
                                                    ? selectedProfile.descipline
                                                    : []
                                                const selectedDiscipline = disciplines[this.state.resourceProfileDisciplineTab]
                                                const selectedDisciplineRows = Array.isArray(selectedDiscipline?.resource_profile_data)
                                                    ? selectedDiscipline.resource_profile_data.map(row => ({
                                                        ...row,
                                                        descipline_name: selectedDiscipline.descipline_name,
                                                    }))
                                                    : []
                                                const selectedStageData = importProfileSections.find(section =>
                                                    section.label.toLowerCase() === String(selectedProfile?.type || '').toLowerCase()
                                                ) || importProfileSections[this.state.resourceProfileTab]
                                                const selectionScopeKey = `${selectedStageData?.key || selectedProfile?.type || this.state.resourceProfileTab}:${selectedDiscipline?.descipline_id ?? this.state.resourceProfileDisciplineTab}`
                                                const selectedImportProfileRow = this.state.selectedImportProfileRow.find(selection => selection.selectionScopeKey === selectionScopeKey)

                                                return (
                                                    <>
                                                        <Tabs
                                                            value={disciplines.length ? this.state.resourceProfileDisciplineTab : false}
                                                            onChange={(event, value) => this.setState({ resourceProfileDisciplineTab: value })}
                                                            centered
                                                            indicatorColor='secondary'
                                                            textColor='secondary'
                                                        >
                                                            {disciplines.map((discipline, index) => (
                                                                <Tab
                                                                    key={`${discipline?.descipline_id || 'discipline'}-${index}`}
                                                                    label={discipline?.descipline_name || this.state.disciplineObj[discipline?.descipline_id] || `Discipline ${index + 1}`}
                                                                />
                                                            ))}
                                                        </Tabs>
                                                        {selectedDiscipline && (
                                                            <Box
                                                                role='tabpanel'
                                                                mt={3}
                                                                width='100%'
                                                            >
                                                                <ResourceProfileTable
                                                                    importProfileView={true}
                                                                    disciplineData={selectedDiscipline}
                                                                    rolesData={this.state.roles}
                                                                    stageData={selectedStageData}
                                                                    data={selectedDisciplineRows}
                                                                    selectedImportProfileRow={selectedImportProfileRow?.project_type_id ?? selectedImportProfileRow?.id ?? null}
                                                                    handleProjectType={(row, stageData) => this.handleProjectType(row, stageData, selectionScopeKey)}
                                                                />
                                                            </Box>
                                                        )}
                                                    </>
                                                )
                                            })()}
                                        </>
                                    )}
                                </Box>
                            </DialogContent>
                        </Dialog>

                        <Paper elevation={3} variant={"outlined"}>
                            {selectedRolesCount > 0 ? (
                                <Box p={1.5}>
                                    <Alert severity="info">
                                        {selectedRolesCount} ({nestedSelectedCount} Role Schedules) {selectedRolesCount === 1 ? 'role is' : 'roles are'} selected.
                                    </Alert>
                                </Box>
                            ) : null}
                            <div onScroll={(e) => {
                                if (e.target.scrollTop > 50 && !this.state.scrollTop) {
                                    this.setState({ scrollTop: true })
                                } else if (e.target.scrollTop < 50 && this.state.scrollTop) {
                                    this.setState({ scrollTop: false })
                                }
                            }}>
                                <TableContainer style={{ maxHeight: window.innerHeight - (225) }}>
                                    <div ref={this.topRef}>
                                        <Table stickyHeader size='small' style={{ zoom: this.state.zoom }} >
                                            <TableHead>
                                                <TableRow className={this.props.classes.tableRow}>
                                                    <TableCell className={classes.leftStickyHeader}>
                                                        <Box display='flex' flexDirection='row' alignItems='center' >
                                                            <Checkbox
                                                                color='primary'
                                                                size='small'
                                                                checked={this.state.allCheck}
                                                                onChange={(e) => this.handleAllCheck(e.target.checked)}
                                                            />
                                                            <Box marginLeft={2}>
                                                                <b>Actions</b>
                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                    {this.state.columns.map((columnLabel, inde) => (
                                                        <TableCell
                                                            key={inde}
                                                            style={{
                                                                ...columnLabel.headerStyle,
                                                                ...(columnLabel.field === 'role_name' ? {
                                                                    position: 'sticky',
                                                                    left: '165px',
                                                                    zIndex: 1099,
                                                                    background: '#F8F8F8'
                                                                } : {}),
                                                                ...(columnLabel.field === 'descipline' ? {
                                                                    position: 'sticky',
                                                                    left: '285px',
                                                                    zIndex: 1098,
                                                                    background: '#F8F8F8'
                                                                } : {}),
                                                            }} >
                                                            <b> {columnLabel.title}</b>
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {roleGroupFilteredData.map((row, index) => (
                                                    <>
                                                        <TableRow
                                                            key={index}
                                                            style={{ cursor: 'pointer', zIndex: 99 }}
                                                            className={this.isRowOpen(row.id) ? this.props.classes.rows : null}
                                                        >
                                                            <TableCell className={classes.leftSticky}
                                                                onClick={(e) => {
                                                                    e.preventDefault()
                                                                    this.setState({
                                                                        selectedUser: row
                                                                    })
                                                                    this.toggleRowOpen(row.id)
                                                                }}
                                                            >
                                                                <Box display="flex" justifyContent='center' alignItems="center">
                                                                    <Tooltip title={row.isChecked ? "remove" : 'Select to delete'}>
                                                                        <Checkbox
                                                                            color='primary'
                                                                            size='small'
                                                                            checked={row.isChecked}
                                                                            onClick={(e) => { e.stopPropagation(); this.handleSelectionChange(row, index) }}
                                                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                                                        />
                                                                    </Tooltip>
                                                                    <Tooltip title="Add Employee">
                                                                        <IconButton
                                                                            color='primary'
                                                                            aria-label="Add Employee"
                                                                            disabled={this.state.addEmployeeDisabled}
                                                                            onClick={(e) => {
                                                                                this.setState({
                                                                                    selectedUser: row
                                                                                })
                                                                                e.stopPropagation();
                                                                                this.getResource(row)
                                                                            }}>
                                                                            <GroupAddIcon color='primary' />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    {!row.editDescipline ?
                                                                        <Tooltip title="Edit Discipline">
                                                                            <IconButton
                                                                                color='primary'
                                                                                aria-label="Edit Discipline"
                                                                                disabled={this.state.addEmployeeDisabled}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    this.editDesciplineFunc(row, true)
                                                                                }}
                                                                            >
                                                                                <EditIcon color='primary' />
                                                                            </IconButton>
                                                                        </Tooltip> : <Box display={'flex'} alignItems={'center'} flexDirection={'row'}>
                                                                            <Tooltip title="Edit Discipline">
                                                                                <IconButton
                                                                                    color='primary'
                                                                                    aria-label="Edit Discipline"
                                                                                    disabled={this.state.addEmployeeDisabled}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        this.submitDescipline(row)
                                                                                    }}
                                                                                >
                                                                                    <CheckIcon color='primary' />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                            <Tooltip title="Edit Discipline">
                                                                                <IconButton
                                                                                    color='primary'
                                                                                    aria-label="Edit Discipline"
                                                                                    disabled={this.state.addEmployeeDisabled}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        this.editDesciplineFunc(row, false)
                                                                                    }}
                                                                                >
                                                                                    <CloseIcon color='primary' />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </Box>}
                                                                </Box>
                                                            </TableCell>
                                                            {this.state.columns.map((columnLabel, i) => (
                                                                <TableCell
                                                                    key={i}
                                                                    onClick={(e) => {
                                                                        this.setState({
                                                                            selectedUser: row
                                                                        })
                                                                        const isDisciplineEditing = columnLabel.field === 'descipline' && row.editDescipline
                                                                        if (!isDisciplineEditing) {
                                                                            this.toggleRowOpen(row.id)
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        ...columnLabel.columnStyle,
                                                                        ...(columnLabel.field === 'role_name' ? {
                                                                            position: 'sticky',
                                                                            left: '165px',
                                                                            zIndex: 110,
                                                                            background: '#F8F8F8'
                                                                        } : {}),
                                                                        ...(columnLabel.field === 'descipline' ? {
                                                                            position: 'sticky',
                                                                            left: '285px',
                                                                            zIndex: 109,
                                                                            background: '#F8F8F8'
                                                                        } : {}),
                                                                    }} >
                                                                    {this.tableCellRender(row, columnLabel)}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                        {this.isRowOpen(row.id) ? (
                                                            <EmpTable
                                                                disabled={this.handleDisabled}
                                                                removeEmployeewithoutReload={this.removeEmployeewithoutReload}
                                                                ref={this.empTableRef}
                                                                multipleSelect={this.state.multipleSelect}
                                                                roleData={row}
                                                                columns={this.state.subTableCol}
                                                                project={this.props.project}
                                                                allRoles={this.state.rolesObj}
                                                                roles={this.state.roles}
                                                                employees={this.state.allEmp}
                                                                isLoading={this.props.isLoading}
                                                                refreshRoles={getActiveRoles}
                                                                owner_delivery_unit={
                                                                    this.state.owner_delivery_unit
                                                                }
                                                                owner_region={this.state.owner_region}
                                                                sector={this.state.disciplineObj}
                                                                prpData={this.prpData}
                                                                editPRPAccess={this.props.editPRPAccess}
                                                                deletePRPAccess={this.props.deletePRPAccess}
                                                                reload={this.handleReload}
                                                                reset={this.handleReset}
                                                                selectedData={this.handleSelectedData}
                                                                selectedEmployees={this.state.selectedEmployees}
                                                                customQtyValues={this.state.customQtyValues}
                                                                rowData={this.handleRowData}
                                                                openDialog={this.handleOpenDialog}
                                                                getSingleRoleData={this.getSingleRoleData}
                                                                linkedWorkTypeRole={this.handleLinkedWorkTypeRole}
                                                            />
                                                        ) : null}
                                                    </>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </TableContainer>
                            </div>
                            {this.state.scrollTop ? <IconButton size='large' onClick={() => { this.scrolltoTop() }} variant='contained' style={{ zIndex: 999, position: 'absolute', right: 40, bottom: 40 }}><ArrowUpwardIcon style={{ fontSize: '40px' }} /></IconButton> : null}
                        </Paper>


                        <Dialog open={this.state.warningDialog} onClose={() => this.setState({ warningDialog: false })} fullWidth>
                            <DialogTitle>
                                Alert
                            </DialogTitle>
                            <DialogContent>
                                <Box sx={{ fontSize: '15px', mb: 2 }}>The following data is incorrect or missing:</Box>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><b>Cell</b></TableCell>
                                                <TableCell><b>Column</b></TableCell>
                                                <TableCell><b>Row</b></TableCell>
                                                <TableCell><b>Message</b></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(Array.isArray(this.state.missingValues) ? this.state.missingValues : []).map((err, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{err.cell || '-'}</TableCell>
                                                    <TableCell>{err.column || '-'}</TableCell>
                                                    <TableCell>{err.row || '-'}</TableCell>
                                                    <TableCell>{err.message || '-'}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </DialogContent>
                            <DialogActions>
                                <Button color='primary' variant='contained' size='small' onClick={() => this.setState({ warningDialog: false })}> Close </Button>
                            </DialogActions>
                        </Dialog>
                        <div>
                            <Dialog open={this.state.modelOpen} onClose={this.handleClose}>
                                <DialogTitle id="form-dialog-title">
                                    Add Role
                                    <IconButton
                                        aria-label="close"
                                        onClick={this.handleClose}
                                        style={{ position: 'absolute', top: '5px', right: '20px' }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </DialogTitle>
                                <DialogContent>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel>Select Role</InputLabel>
                                        <Select
                                            id="rolesToPost"
                                            name="rolesToPost"
                                            value={Number(this.state.rolesToPost)}
                                            onChange={this.handleChange}
                                            label="Select Role"
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {this.state.roles.map(role => (
                                                <MenuItem value={role.id}>{role.job_roles}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel>Select Discipline</InputLabel>
                                        <Select
                                            id="discipline"
                                            name="discipline"
                                            value={Number(this.state.discipline)}
                                            onChange={this.handleChange}
                                            label="Select Discipline"
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {this.state.disciplineArr.map(disc => (
                                                <MenuItem value={disc.id}>{disc.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        onClick={this.handleClose}
                                        color="secondary"
                                        variant='contained'
                                        size='small'
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        color="primary"
                                        variant='contained'
                                        size='small'
                                        onClick={this.addRoleOps}
                                        disabled={!this.state.rolesToPost || !this.state.discipline || this.state.addDisabled}
                                    >
                                        Add
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            <Dialog open={this.state.rowDelete} onClose={() => this.setState({ rowDelete: false })}>
                                <DialogTitle id="form-dialog-title">
                                    Delete Role
                                </DialogTitle>
                                <DialogContent>
                                    <Typography>Are you sure to delete these roles </Typography>
                                    <Box display={'flex'} flexDirection={'column'}>
                                        <ul>
                                            {this.state.deleteRowData.map((value, i) =>
                                                <li key={i}>{value.role_name}</li>
                                            )}
                                        </ul>
                                    </Box>
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        onClick={() => this.setState({ rowDelete: false })}
                                        color="secondary"
                                        variant='contained'
                                        size='small'
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant='contained'
                                        size='small'
                                        color="primary"
                                        onClick={this.deleteRole}
                                        disabled={this.state.deleteDisabled1}
                                    >
                                        Delete
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>

                        <Dropzone
                            fileDownload={true}
                            open={this.state.dropZoneModal}
                            onClose={this.dropzoneClose}
                            onChange={(e) => this.fileToRead(e)}
                            preview={this.reviewModalOpen}
                            disabled={this.state.buttonDisabled}
                        />

                        <Modal
                            open={this.state.reviewModal}
                            close={this.reviewModalClose}
                            onUpload={this.bulkUpload}
                            disabled={this.state.bulkUploadDisabled}
                            columns={this.state.reviewTableCol}
                            data={this.state.reviewTableData}
                            loading={this.state.bulkUploadLoader}
                            title={"PRP excel data review"}
                        />

                        {/* Qty apply for multiple Employees */}
                        <Dialog open={this.state.showDialog} onClose={this.closeShowDialog} aria-labelledby="form-dialog-title" >
                            <DialogTitle id="form-dialog-title">
                                <Typography variant="h5">Schedule's Bulk Update</Typography>
                            </DialogTitle>
                            <DialogContent>
                                <div>
                                    {this?.state?.customQtyValues?.map((element, index) => (
                                        <Box display={'flex'} flexDirection={'column'} marginBottom={"5px"}>
                                            <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                <Box flexGrow={1} fontSize={'14px'}>
                                                    {/* {this.state.selectedEmployee.employee}&nbsp;({this.state.rolesObj[element.role_id]}) */}
                                                    <b>{this.state.rolesObj[element.role_id]}</b>
                                                </Box>

                                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                                    <FormControl variant="outlined" className={classes.formControl} size="small">
                                                        <InputLabel>Type</InputLabel>
                                                        <Select
                                                            id="rolesToPost"
                                                            name="rolesToPost"
                                                            value={Number(element.type)}
                                                            onChange={(e) => {
                                                                this.handleType(e, index, element.role_id)
                                                            }}
                                                            label="Type">
                                                            <MenuItem value={0}>
                                                                <em>None</em>
                                                            </MenuItem>
                                                            <MenuItem value={1}>
                                                                Project
                                                            </MenuItem>
                                                            <MenuItem value={2}>
                                                                Tender
                                                            </MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                                {/* <Box marginLeft={'5px'}>
                                                    <IconButton aria-label="close" onClick={() => this.addCustomField(element.role_id)}>
                                                        <AddIcon />
                                                    </IconButton>
                                                </Box> */}
                                            </Box>
                                            <Box marginTop={'5px'}>
                                                {element.shdl_data.map((ele, i) => (
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={2} sm={2}>
                                                            <IconButton aria-label="remove"
                                                                style={{ marginTop: '10px' }}
                                                                onClick={(e) => this.removeCustomQty(e, index, i)}

                                                                disabled={element.shdl_data.length === 1}
                                                            >
                                                                <RemoveIcom />
                                                            </IconButton>
                                                        </Grid>
                                                        <Grid item xs={12} sm={5}>
                                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                <KeyboardDatePicker
                                                                    format="dd/MM/yyyy"
                                                                    margin="normal"
                                                                    id={'from'}
                                                                    label="From"
                                                                    // minDate={this.props.project.contractor_start_date}
                                                                    // maxDate={this.props.project.contractor_end_date}
                                                                    value={ele.from ? ele.from : undefined}
                                                                    error={ele.from && ele.to && moment(ele.to).isBefore(ele.from)}
                                                                    onChange={(e) => this.handleCustomFromDate(e, index, i)}
                                                                    KeyboardButtonProps={{
                                                                        'aria-label': 'change date',
                                                                    }}
                                                                    className={classes.date}
                                                                />
                                                            </MuiPickersUtilsProvider>
                                                        </Grid>
                                                        <Grid item xs={12} sm={5}>
                                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                <KeyboardDatePicker
                                                                    format="dd/MM/yyyy"
                                                                    margin="normal"
                                                                    id={'to'}
                                                                    label="To"
                                                                    // minDate={this.props.project.contractor_start_date}
                                                                    // maxDate={this.props.project.contractor_end_date}
                                                                    value={ele.to ? ele.to : undefined}
                                                                    error={ele.from && ele.to && moment(ele.to).isBefore(ele.from)}
                                                                    onChange={(e) => this.handleCustomToDate(e, index, i)}
                                                                    KeyboardButtonProps={{
                                                                        'aria-label': 'change date',
                                                                    }}
                                                                    className={classes.date}
                                                                />
                                                            </MuiPickersUtilsProvider>
                                                        </Grid>
                                                        {/* <Grid item xs={12} sm={2} style={{ marginTop: '10px' }}>
                                                            <TextField
                                                                disabled={true}
                                                                id={'qty'}
                                                                label="Qty/Week"
                                                                type="number"
                                                                fullWidth
                                                                margin="dense"
                                                                value={ele.qty}
                                                                onChange={(e) => this.handleCustomQty(e, i, element.role_id)}
                                                            />
                                                        </Grid> */}
                                                        {ele.error === true ?
                                                            <p style={{ marginTop: '0', marginLeft: '100px', color: '#F44336' }}
                                                            >{ele.errorMsg}</p> : null}
                                                    </Grid>
                                                ))}
                                            </Box>
                                        </Box>
                                    ))}
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.closeShowDialog} color="secondary" size='small' variant='contained'>
                                    Cancel
                                </Button>
                                <Button disabled={this.state.addQtyDisbaled || !hasBulkScheduleData} color="primary" size='small' variant='contained' onClick={this.applyCustomQty}>
                                    Apply
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/*  Qty apply for single Employee */}
                        <Dialog open={this.state.singleShowDialog} onClose={this.closeSingleDialog} aria-labelledby="form-dialog-title" >
                            <DialogTitle id="form-dialog-title">
                                Add Qty
                            </DialogTitle>
                            <DialogContent>
                                <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                                    <Box display={'flex'} flexDirection={'row'}>
                                        <Box flexGrow={1}>
                                            {this.state.selectedEmployee?.emp_last_name ? (this.state.selectedEmployee?.emp_first_name + " " + this.state.selectedEmployee?.emp_last_name) : ''}&nbsp;({this.state.selectedEmployee.role_name})
                                        </Box>
                                        <Box>
                                            <FormControl variant="outlined" className={classes.formControl} size="small">
                                                <InputLabel>Type</InputLabel>
                                                <Select
                                                    id="rolesToPost"
                                                    name="rolesToPost"
                                                    value={Number(this.state.type)}
                                                    disabled={this.state.empIsArchived}
                                                    onChange={(e) => {
                                                        this.handleSingleType(e)
                                                    }}
                                                    label="Select Type"
                                                >
                                                    <MenuItem value={0}>
                                                        <em>None</em>
                                                    </MenuItem>
                                                    <MenuItem value={1}>
                                                        Project
                                                    </MenuItem>
                                                    <MenuItem value={2}>
                                                        Tender
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box marginLeft={'5px'}>
                                            <IconButton aria-label="close"
                                                disabled={this.state.empIsArchived}
                                                onClick={() => this.setState({ singleShowDialog: false, addResource: true })}>
                                                <AddIcon />
                                            </IconButton>
                                        </Box>
                                    </Box>

                                    {this.state?.singleCustomQtyValues?.map((element, i) => (
                                        <Grid container spacing={1}>
                                            <Grid item xs={2}>
                                                <PopupState variant="popover" popupId="demo-popup-popover">
                                                    {(popupState) => (
                                                        <div>
                                                            <IconButton aria-label="remove"
                                                                style={{ marginTop: '10px' }}  {...bindTrigger(popupState)}
                                                                disabled={this.state?.singleCustomQtyValues.length === 1 || this.state.empIsArchived}
                                                            >
                                                                <RemoveIcom />
                                                            </IconButton>
                                                            <Popover
                                                                {...bindPopover(popupState)}
                                                                anchorOrigin={{
                                                                    vertical: 'bottom',
                                                                    horizontal: 'center',
                                                                }}
                                                                transformOrigin={{
                                                                    vertical: 'top',
                                                                    horizontal: 'center',
                                                                }}>
                                                                <List>
                                                                    <ListItem onClick={(e) => { this.deleteOrUnallocateSchedules('unallocate', element, i); popupState.close() }} button >Unallocate</ListItem>
                                                                    <ListItem onClick={(e) => {
                                                                        this.deleteCheck(element, i)
                                                                            ; popupState.close()
                                                                    }} button>Delete</ListItem>
                                                                </List>
                                                            </Popover>
                                                        </div>
                                                    )}
                                                </PopupState>
                                            </Grid>
                                            {this.state.linkedWorkType.length === 0 ? null :
                                                <Grid item xs={3} sm={3} style={{ marginTop: '20px' }}>
                                                    <TextField
                                                        fullWidth
                                                        id="work_type"
                                                        // margin="dense"
                                                        value={element.work_type}
                                                        label={"Work Type"}
                                                        select
                                                        disabled={this.state.empIsArchived}
                                                        size='small'
                                                        onChange={(e) => this.handleWorkType(e, i)}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left"
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left"
                                                            },
                                                            getContentAnchorEl: null
                                                        }}>
                                                        {this.state.linkedWorkType.map((ele, k) => (
                                                            <MenuItem value={ele.id} key={k}>
                                                                {ele.name + (!ele.short_form ? '' : ` (${ele.short_form})`)}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>}
                                            <Grid item xs={this.state.linkedWorkType.length === 0 ? 4 : 3}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                        format="dd/MM/yyyy"
                                                        margin="normal"
                                                        id={'from'}
                                                        label="From"
                                                        disabled={this.state.empIsArchived}
                                                        // minDate={this.props.project.contractor_start_date}
                                                        // maxDate={this.props.project.contractor_end_date}
                                                        value={element.from_date ? element.from_date : undefined}
                                                        error={element.from_date && element.to_date && moment(element.to_date).isBefore(element.from_date)}
                                                        onChange={(e) => this.handleSingleCustomFromDate(e, i)}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        className={classes.date}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={this.state.linkedWorkType.length === 0 ? 4 : 3}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                        format="dd/MM/yyyy"
                                                        margin="normal"
                                                        id={'to'}
                                                        label="To"
                                                        disabled={this.state.empIsArchived}
                                                        // minDate={this.props.project.contractor_start_date}
                                                        // maxDate={this.props.project.contractor_end_date}
                                                        value={element.to_date ? element.to_date : undefined}
                                                        error={element.from_date && element.to_date && moment(element.to_date).isBefore(element.from_date)}
                                                        onChange={(e) => this.handleSingleCustomToDate(e, i)}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        className={classes.date}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={this.state.linkedWorkType.length === 0 ? 3 : 1} sm={1} style={{ marginTop: '10px' }}>
                                                <TextField
                                                    id={'qty'}
                                                    label="Qty/Week"
                                                    disabled={this.state.empIsArchived}
                                                    type="number"
                                                    fullWidth
                                                    margin="dense"
                                                    value={element.qty}
                                                    onChange={(e) => this.handleSingleCustomQty(e, i)}
                                                />
                                            </Grid>
                                            {element.error === true ?
                                                <p style={{ marginTop: '0', marginLeft: '100px', color: '#F44336' }}
                                                >{element.errorMsg}</p> : null}
                                        </Grid>
                                    ))}
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.closeSingleDialog} color="secondary" size='small' variant='contained'>
                                    Cancel
                                </Button>
                                <Button disabled={this.state.addQtyDisbaled} color="primary" size='small' variant='contained' onClick={() => this.applySingleCustomQty(true)}>
                                    Apply
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            fullWidth
                            maxWidth={this.state.allocationDialogSize}
                            open={this.state.allocationDialog}
                            TransitionComponent={Transition}
                            disableEnforceFocus >
                            <DialogTitle>
                                <Box display={'flex'} flexDirection={'row'} width={'100%'} alignItems={'center'}>
                                    <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
                                        {"Assign Employee / Assign SubContractor / Add ATR / Add Demand / Split Demand To Role"}
                                    </Typography>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </DialogTitle>
                            <DialogContent>
                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                    <Tabs
                                        value={this.state.tabValue} onChange={(e, newValue) => this.handleTabChange(e, newValue)} aria-label="simple tabs example">
                                        <Tab label="Assign Employee" />
                                        <Tab label="Assign SubContractor" />
                                        <Tab label='Assign ATR' />
                                        <Tab label="Add Demand" />
                                        <Tab label="Split Demand To Role" />
                                    </Tabs>
                                </Box>
                                <Box margin={'10px'}>
                                    {this.state.tabValue === 0 ?
                                        <UserAllocation
                                            isRemoveBackButton={false}
                                            securedTab={true}
                                            type={'others'}
                                            getDialogSize={this.getDialogSize}
                                            closeDialog={this.closeDialog}
                                            allocationData={{ prj: { crm_id: this.props.project.id, crm_name: this.props.project.name, descipline: this.state?.selectedUser?.descipline } }}
                                            role={this.state.role}
                                        /> :
                                        this.state.tabValue === 1 ?
                                            <AssignSubContractor
                                                securedTab={true}
                                                addDemandwithoutEmployee={true}
                                                getMenu={this.getMenu}
                                                crm={{ 'crm_id': this.props.project.id, 'crm_name': this.props.project.name, descipline: this.state.selectedEmployee.descipline }}
                                                user={this.state.selectedUser}
                                                closeDialog={this.closeDialog}
                                                increaseDialogSize={this.increaseDialogSize}
                                                tabChangeAlert={this.tabChangeAlert}
                                                reduceDialogSize={this.decreaseDialogSize}
                                                role={this.state.role}
                                                allocationData={this.props.allocationData}
                                            /> :
                                            this.state.tabValue === 2 ?
                                                <AtrAllocation
                                                    isRemoveBackButton={false}
                                                    securedTab={true}
                                                    type={'others'}
                                                    getDialogSize={this.getDialogSize}
                                                    closeDialog={this.closeDialog}
                                                    allocationData={{ prj: { crm_id: this.props.project.id, crm_name: this.props.project.name, descipline: this.state?.selectedUser?.descipline } }}
                                                    role={this.state.role}
                                                /> :
                                                this.state.tabValue === 3 ?
                                                    <AllocateSchedules
                                                        securedTab={true}
                                                        addDemandwithoutEmployee={true}
                                                        getMenu={this.getMenu}
                                                        isAddDemandTab={true}
                                                        isRemoveBackButton={true}
                                                        tabChangeAlert={this.tabChangeAlert}
                                                        crm={{ 'crm_id': this.props.project.id, 'crm_name': this.props.project.name, descipline: this.state?.selectedUser?.descipline }}
                                                        user={this.state.selectedUser}
                                                        disciplineObj={this.state.disciplineObj}
                                                        role={this.state.role}
                                                        closeDialog={this.closeDialog}
                                                        allocationData={this.props.allocationData} /> :
                                                    <SplitDemandRole
                                                        securedTab={true}
                                                        role={this.state.role}
                                                        roles={this.state.roles}
                                                        crm={{ 'crm_id': this.props.project.id, 'crm_name': this.props.project.name }}
                                                        user={this.state.selectedUser}
                                                        tabChangeAlert={this.tabChangeAlert}
                                                        closeDialog={this.closeDialog}
                                                        project={this.props.project}
                                                        allocationData={this.props.allocationData}
                                                        increaseDialogSize={this.increaseDialogSize}
                                                        reduceDialogSize={this.decreaseDialogSize}
                                                    />
                                    }
                                </Box>
                            </DialogContent>
                        </Dialog>

                        <Dialog
                            fullWidth
                            maxWidth={this.state.allocationDialogSize}
                            open={this.state.addResource}
                            TransitionComponent={Transition}
                            disableEnforceFocus >
                            <DialogTitle>
                                <Box display={'flex'} flexDirection={'row'} width={'100%'} alignItems={'center'}>
                                    <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
                                        {this.state.selectedEmployee?.emp_id ? ("Add Resource to " + this.state.selectedEmployee.emp_first_name + " " + this.state.selectedEmployee.emp_last_name) : "Add Resource"}
                                    </Typography>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </DialogTitle>
                            <DialogContent>
                                {this.state.selectedEmployee?.emp_id ?
                                    <UserAllocation
                                        type={'others'}
                                        getDialogSize={this.getDialogSize}
                                        closeDialog={this.closeDialog}
                                        allocationData={
                                            {
                                                prj: { crm: this.props.project.id, crm_name: this.props.project.name },
                                                emp: {
                                                    employee_id: this.state.selectedEmployee.emp_id,
                                                    first_name: this.state.selectedEmployee.emp_first_name,
                                                    last_name: this.state.selectedEmployee.emp_last_name,
                                                    role_name: this.state.selectedEmployee.role_name,
                                                    descipline: this.state.selectedEmployee.descipline
                                                },
                                            }}
                                    /> :
                                    <UserAllocation
                                        type={'others'}
                                        getDialogSize={this.getDialogSize}
                                        closeDialog={this.closeDialog}
                                        allocationData={{ prj: { crm_id: this.props.project.id, crm_name: this.props.project.name } }}
                                        role={{
                                            role_id: this.state.selectedEmployee.role_id,
                                            role_name: this.state.selectedEmployee.role_name,
                                            descipline: this.state.selectedEmployee.descipline
                                        }}
                                    />
                                }
                            </DialogContent>
                        </Dialog>

                        <Dialog open={this.state.unallocateDeleteDialog}>
                            <DialogTitle>Confirmation</DialogTitle>
                            <DialogContent>This Schedule is linked to the Reporting Instruction. Do you want to delete?</DialogContent>
                            <DialogActions>
                                <Button color='primary' size='small' variant='contained' onClick={() => this.setState({ unallocateDeleteDialog: false, selectedElement: null, selectedIndex: null })}>Cancel</Button>
                                <Button color='primary' size='small' variant='contained' onClick={() => {
                                    this.deleteOrUnallocateSchedules('delete', this.state.selectedElement, this.selectedIndex)
                                }}>Unarchive</Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog fullWidth maxWidth="sm" open={this.state.dateDialog} onClose={() => this.setState({ dateDialog: false })}>
                            <DialogTitle>Select Dates</DialogTitle>
                            <DialogContent>
                                <Box display={'flex'} justifyContent={'space-around'} alignItems={'center'}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id={'from'}
                                            label="Start Date"
                                            value={this.state.bulkDates.start_date ? this.state.bulkDates.start_date : moment()}
                                            error={this.state.bulkDates.start_date && this.state.bulkDates.end_date && moment(this.state.bulkDates.end_date).isBefore(this.state.bulkDates.start_date)}
                                            onChange={(e) => this.setState({ bulkDates: { ...this.state.bulkDates, start_date: e } }, () => {
                                                console.log(this.state.bulkDates)
                                            })}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            className={classes.date}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id={'from'}
                                            label="End Date"
                                            // minDate={this.props.project.contractor_start_date}
                                            // maxDate={this.props.project.contractor_end_date}
                                            value={this.state.bulkDates.end_date ? this.state.bulkDates.end_date : moment()}
                                            error={this.state.bulkDates.start_date && this.state.bulkDates.end_date && moment(this.state.bulkDates.end_date).isBefore(this.state.bulkDates.start_date)}
                                            onChange={(e) => this.setState({ bulkDates: { ...this.state.bulkDates, end_date: e } })}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            className={classes.date}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button color='primary' size='small' variant='contained' onClick={() => this.setState({ dateDialog: false })}>Cancel</Button>
                                <Button color='primary' size='small' variant='contained' onClick={() => this.submitRoleId()} >Submit</Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog maxWidth="sm" open={this.state.coffeeLoading} aria-labelledby="form-dialog-title">
                            <DialogContent>
                                <Box m={2} p={2}>
                                    <CoffeeLoading />
                                </Box>
                            </DialogContent>
                        </Dialog>
                        <Dialog open={this.state.openConfirmationDialog} onClose={() => this.setState({ openConfirmationDialog: false })} aria-labelledby="form-dialog-title" >
                            <DialogTitle id="form-dialog-title">
                                Confirmation
                            </DialogTitle>
                            <DialogContent>
                                Are you sure you want to switch tabs? All unsaved data will be lost.
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ openConfirmationDialog: false })} size='small' variant='contained' color="primary">
                                    Cancel
                                </Button>
                                <Button onClick={(e) => this.switchTabs(e)} size='small' variant='contained' color="primary">
                                    Switch
                                </Button>
                            </DialogActions>
                        </Dialog>


                        <Dialog fullWidth maxWidth='md' open={this.state.bulkDisplayDialog} onClose={() => this.setState({ bulkDisplayDialog: false })}>
                            <DialogTitle>
                                Bulk Display Data
                            </DialogTitle>
                            <DialogContent>
                                <Box margin={1}>
                                    <TableContainer component={Paper} variant='outlined' style={{ maxHeight: 420 }}>
                                        <Table stickyHeader size='small'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell padding='checkbox'>
                                                        <Checkbox
                                                            color='primary'
                                                            checked={bulkDisplayAllChecked}
                                                            indeterminate={bulkDisplaySelectedRowIds.length > 0 && !bulkDisplayAllChecked}
                                                            onChange={(e) => this.handleBulkDisplaySelectAll(bulkDisplayRows, e.target.checked)}
                                                        />
                                                    </TableCell>
                                                    <TableCell><b>Role Schedule Id</b></TableCell>
                                                    <TableCell><b>Role</b></TableCell>
                                                    <TableCell><b>From Date</b></TableCell>
                                                    <TableCell><b>To Date</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {bulkDisplayRows.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={6} align='center'>No data available</TableCell>
                                                    </TableRow>
                                                ) : bulkDisplayRows.map((row, index) => {
                                                    const rowId = this.getBulkDisplayRowId(row, index)
                                                    const checked = bulkDisplaySelectedRowIds.includes(rowId)
                                                    const nestedRoleSchedules = Array.isArray(row.role_schedules) ? row.role_schedules : []
                                                    return (
                                                        <React.Fragment key={rowId}>
                                                            <TableRow
                                                                hover
                                                                selected={checked}
                                                            >
                                                                <TableCell padding='checkbox'>
                                                                    <Checkbox
                                                                        color='primary'
                                                                        checked={checked}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onChange={(e) => this.handleBulkDisplayRowSelection(row, index, e.target.checked)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>{row.template_id || row.schedule_id || row.id || '-'}</TableCell>
                                                                <TableCell>{row.template_role_schedule || row.role || '-'}</TableCell>
                                                                <TableCell>{row.new_from_date ? row.new_from_date : '-'}</TableCell>
                                                                <TableCell>{row.new_to_date ? row.new_to_date : '-'}</TableCell>
                                                            </TableRow>
                                                            {nestedRoleSchedules.length > 0 ? (
                                                                <TableRow>
                                                                    <TableCell colSpan={6} style={{ background: '#fafafa' }}>
                                                                        <Box pl={4} pr={1} pt={1} pb={1}>
                                                                            <Typography variant='body2' style={{ fontWeight: 600, marginBottom: 6 }}>
                                                                                Role Schedules under this {row.template_id ? 'Template' : 'Schedule'} ({nestedRoleSchedules.length})
                                                                            </Typography>
                                                                            <Table size='small'>
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        <TableCell><b>Role Schedule Id</b></TableCell>
                                                                                        <TableCell><b>Qty</b></TableCell>
                                                                                        <TableCell><b>From Date</b></TableCell>
                                                                                        <TableCell><b>To Date</b></TableCell>
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {nestedRoleSchedules.map((nestedRow, nestedIndex) => (
                                                                                        <TableRow key={`${rowId}-nested-${nestedRow.id || nestedRow.role_schedule_id || nestedRow.schedule_id || nestedIndex}`}>
                                                                                            <TableCell>{nestedRow.prp_role_id || '-'}</TableCell>
                                                                                            <TableCell>{nestedRow.qty || '-'}</TableCell>
                                                                                            <TableCell>{nestedRow.from_date ? moment(nestedRow.from_date).format('DD/MM/YYYY') : '-'}</TableCell>
                                                                                            <TableCell>{nestedRow.to_date ? moment(nestedRow.to_date).format('DD/MM/YYYY') : '-'}</TableCell>
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </Box>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ) : null}
                                                        </React.Fragment>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button color='primary' size='small' variant='contained' onClick={() => this.setState({ bulkDisplayDialog: false, bulkDisplayExpandedRowIds: [] })}>Close</Button>
                                <Button color='primary' disabled={this.state.bulkDisplaySelectedRowIds.length === 0} size='small' variant='contained' onClick={() => this.submitBulkDisplay()} >Submit</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                }
            </div>
        )
    }
}

export default withSnackbar(withStyles(useStyle)(PRPTemplate))